import { Line } from './../../../apps/shoppingCart/interfaces/cartObject';
import { userIdentity } from './../../../globals';
import { Subject } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  Field,
  FieldDataType,
  SectionAdditionalInformation,
} from './../../../models/module-structure';
import { BillOfMaterialService } from './../../../services/BillOfMaterial.service';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ElementRef,
  ApplicationRef,
  ChangeDetectorRef,
} from '@angular/core';
import { LayoutService } from '../../layout.service';
import {
  EventType,
  RecordCategory,
  RecordLine,
  RecordModel,
  RecordProperties,
  SourceDocument,
  SpecialLines,
} from '../../record-model';
import {
  ModuleStructure,
  Section,
  Values,
} from 'src/app/models/module-structure';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { takeUntil } from 'rxjs/operators';
import { RecordsListComponent } from '../../records-list/records-list.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import * as g from '../../../globals';
import * as accounting from 'accounting';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FieldValueChangedArgs } from '@app/layout/field-value-changed-args';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LineAddedArgs } from '@app/layout/line-added-args';
import { ImportDocItemsComponent } from '../data-actions/import-doc-items/import-doc-items.component';
import { filter, take } from 'rxjs/operators';
import * as businessDoc from '../../../models/business/documents';
import { Router } from '@angular/router';

@Component({
  selector: 'app-line-section',
  templateUrl: './line-section.component.html',
  styleUrls: ['./line-section.component.less'],
})
export class LineSectionComponent implements OnInit, AfterViewInit, OnDestroy {
  workingWithLines: boolean;
  subscribers: any;
  getLineKey(data: RecordLine): any {
    data.Properties.find((prop) => prop.Name === this.section.KeyPropertyName)
      .ValueAsObject;
  }

  @ViewChild('sectionTable', { static: false })
  nzTableComponent?: NzTableComponent<RecordLine>;

  @ViewChild('sectionTable') private myScrollContainer: ElementRef;

  private destroy$ = new Subject();

  @Input() fromLog: boolean = false;
  @Input() moduleStructure: ModuleStructure;
  @Input() section: Section;
  @Input() recordModel: RecordModel;
  @Input() defaultVals: Values;
  @Input() actionType = '';
  @Input() parentRecordModel: RecordModel;
  @Input() parentComponent: any;
  scrollY: string = '';

  deleteIsOutOfActions = false;
  specialTextIsHTML = g.specialTextIsHTML;
  allowBulkLineDelete = g.allowBulkLineDelete;
  allowBulkLineClose = false;
  closingLines = false;

  loading = false;
  bomLoading = false;
  enablePaginationInLineSection = g.enablePaginationInLineSection;
  enableItemFileImportation = false;
  pageSizeInLineSection = g.pageSizeInLineSection;

  setOfCheckedId = new Set<number>();
  setOfCheckedIdFromParent = new Set<{ id: number; fromParent: boolean }>();
  bulkDeleteActivated = false;

  _recordCategory: RecordCategory;
  get recordCategory(): RecordCategory {
    if (!this._recordCategory) {
      this._recordCategory = this.recordModel.Categories.find(
        (cat) => cat.Id === this.section.XmlTagName,
      );
    }
    return this._recordCategory;
  }

  set recordCategory(value: RecordCategory) {
    // do nothing;
  }

  //_sectionBtnsDisabled = false;
  /*get sectionBtnsDisabled(): boolean {
    let headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'Documents'
    );

    if (headerCat != null && headerCat !== undefined) {
      let cardCode = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode'
      )?.ValueAsObject;

      if (cardCode == null || cardCode === undefined || cardCode === '') {
        return true;
      }
    }
    return false;
  }*/

  lines: RecordLine[] = [];
  sLines: SpecialLines[] = [];
  deletedLines: RecordLine[] = [];
  // specialLiens: SpecialLiens[] = [];
  specialLinesData: RecordLine[] = [];
  specialLinesFieldsToRender: any[] = [];
  specialLineSection: Section;
  fieldsToRender: any[] = [];
  tableWidth = 0;
  lineSection = false;
  screenSize = '';
  fields: any[];
  fieldGroups: any;
  thereIsCenter: boolean;
  fieldGroupCount: number;
  fieldGroupKeys: any[];
  quantityField: any;
  itemCodeField: any;
  itemCodeTitle = 'Item No.';
  countedField: any;
  openQuantityField: any;
  quantityFieldTitle = 'Quantity';
  openQuantityFieldTitle = 'Open Qty';
  warehouseCodeField: any;
  fromWarehouseField: any;
  subTotals = [];
  isBomExists = false;
  subtotalIndex = 0;
  isSectionAttachment = false;
  textRowToAdd: SpecialLines = {
    LineSeq: 0,
    LineType: '',
    Id: 10000,
  };
  get additionalInformation(): SectionAdditionalInformation {
    return this.section.AdditionalInformationParsed;
  }

  displayActionForLine = false;
  listOfLinesVisible = false;
  afterLineNum = -1;
  linesList: any[] = [];

  sectionLinesVal = [];
  recordCategoryLinesLength = -1;
  recordCategorySpecialLinesLength = -1;
  itemsToImport: string = '';
  enableItemImportation = g.enableItemImportation;

  showCopyFromDrawer = false;
  documentSources: SourceDocument[];
  openDocumentRows: any[];
  minimizedOpenDocumentRowsForBA: any[];
  filters = {
    docNum: '',
    itemCode: '',
    description: '',
    numAtCard: '',
    quotName: '',
  };

  filteredData = [];
  //for blanketAgreement
  blanketAgreementStatus = '';
  //copiedQuotEntries: string[] = [];
  //end

  enableMovingLineInUpdateMode = true;
  allowAddLineWnenClose = false;

  config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
    height: '75px',
    toolbar: [
      ['misc', ['undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'link', 'hr']],
    ],
    codeviewFilter: true,
    codeviewFilterRegex:
      /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true,
    buttons: {},
  };

  get sectionLines(): any[] {
    if (
      this.recordCategoryLinesLength === this.recordCategory.Lines.length &&
      this.recordCategorySpecialLinesLength ===
        this.recordCategory.SpecialLines?.length
    ) {
      return this.sectionLinesVal;
    } else {
      this.prepareSectionLines();
      return this.sectionLinesVal;
    }
  }

  constructor(
    private modalService: NzModalService,
    private layoutService: LayoutService,
    private billOfMaterialService: BillOfMaterialService,
    private notificationService: NzNotificationService,
    private message: NzMessageService,
    private drawerService: NzDrawerService,
    private appRef: ApplicationRef,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.layoutService.afterLoadBom.subscribe((args: LineAddedArgs) => {
      try {
        const documentsCat = args.recordModel.Categories.find(
          (x) => x.Id === args.section.XmlTagName,
        );
        const documentsSection = args.moduleStructure.module.Sections.find(
          (x) => x.XmlTagName === args.section.XmlTagName,
        );

        console.log(args);

        const specialLines = this.recordCategory.SpecialLines
          ? this.recordCategory.SpecialLines
          : [];

        specialLines.forEach((specialLine, index) => {
          let line = documentsCat.Lines.find(
            (l) =>
              l.Properties.find((p) => p.Name === 'LineNum').ValueAsObject ===
              specialLine.AftLineNum,
          );
          if (
            /*line.TreeTypeProp.ValueAsObject === 'iIngredient' ||
            line.TreeTypeProp.ValueAsObject === 'I' ||*/
            line.TreeTypeProp.ValueAsObject === 'iSalesTree' ||
            line.TreeTypeProp.ValueAsObject === 'S'
          ) {
            this.setOfCheckedId.add(specialLine.Id);
          }
        });
        this.moveLinesDown(true, true);
      } catch (e) {
        console.log(
          'An error occured while trying to execute lineAdded',
          args,
          e,
        );
      }
    });
  }

  ngAfterViewInit(): void {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrolledIndexChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: number) => {});

    if (this.actionType === 'View') {
      const parsedSection = g.parseCustomConfiguration(
        g.allowAddLinesEvenWhenClose,
      );
      this.allowAddLineWnenClose = false;
      if (
        parsedSection.hasOwnProperty(this.recordModel.ObjectKey) &&
        Array.isArray(parsedSection[this.recordModel.ObjectKey]) &&
        parsedSection[this.recordModel.ObjectKey].length > 0
      ) {
        let sectionTobeEditableOnClose: string[] = [];
        sectionTobeEditableOnClose = parsedSection[this.recordModel.ObjectKey];
        this.allowAddLineWnenClose =
          sectionTobeEditableOnClose.findIndex(
            (x) => x === this.section.XmlTagName,
          ) !== -1;
      }
    }
  }

  trackByLineId(_: number, data: RecordLine): number {
    return data.Id;
  }

  ngOnDestroy(): void {
    if (this.subscribers != null && this.subscribers != undefined) {
      this.subscribers.forEach((sub) => {
        sub.unsubscribe();
      });
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    var docsToCheck = g.enableItemFileImportationForDocuments.split(',');
    this.enableItemFileImportation =
      docsToCheck.indexOf(this.recordModel.ObjectKey) !== -1;

    this.lines = this.getSectionCategory().Lines;
    this.fieldsToRender = this.getFieldsToRender();
    //this.enablePaginationInLineSection = this.section.AdditionalInformationParsed.EnablePaging;
    //this.pageSizeInLineSection = this.section.AdditionalInformationParsed.DefaultPageSize;

    if (this.section.XmlTagName === 'Document_Lines') {
      this.subtotalIndex = this.fieldsToRender.findIndex(
        (x) => x.PropertyName === 'LineTotal',
      );
    }
    if (this.section.XmlTagName === 'BWEBAttachments') {
      this.isSectionAttachment = true;
    }

    if (this.recordModel.ObjectKey === 'BlanketAgreement') {
      let blanketHeaderCat = this.recordModel.Categories.find(
        (cat) => cat.Id === 'BlanketAgreement',
      );
      this.blanketAgreementStatus = blanketHeaderCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'Orig_Status',
      )?.ValueAsObject;
    }

    this.openDocumentRows = [];
    this.minimizedOpenDocumentRowsForBA = [];
    //this.copiedQuotEntries = [];
    this.filteredData = [];

    // added by Noor, and commented by Tom
    /*if (!this.additionalInformation.FixedHeader) {
      this.additionalInformation.FixedHeader = true;
      this.additionalInformation.TableFixedHeight = 250;
    }*/

    this.tableWidth = this.getTableWidth();
    this.prepareSectionFields();

    this.screenSize = this.layoutService.screenSize;
    this.layoutService.screenSizeEmitter.subscribe((d) => {
      this.screenSize = d;
    });

    this.layoutService.submitDeliverSchedule.subscribe((d) => {
      //this.processDeliverSchedule(d);
    });

    if (this.section.XmlTagName === 'Document_Lines') {
      this.lineSection =
        this.section.AdditionalInformationParsed.AllowAddTextRow;
      this.specialLinesFieldsToRender = this.getSpecialFieldsToRender();
      this.SpecialLinesInit();
      this.updateSubtotals();
    } else {
      this.lineSection = false;
    }

    if (this.section.XmlTagName === 'Document_Lines') {
      const subscriber = this.billOfMaterialService.addLineEmitter.subscribe(
        () => {
          this.addLineToTable();
        },
      );

      const subscriber2 =
        this.billOfMaterialService.deleteLineEmitter.subscribe((args) => {
          console.log(args.FormGUID);
          if (this.recordModel.FormGUID === args.FormGUID) {
            this.deleteRow(args.Id, this.bulkDeleteActivated);
          }
        });

      if (this.subscribers == null || this.subscribers == undefined) {
        this.subscribers = [];
      }

      this.subscribers.push(subscriber);
      this.subscribers.push(subscriber2);
    }

    this.layoutService.fieldValueChanged.subscribe((data) => {
      if (
        data.sectionTagName === 'Document_Lines' &&
        data.recordProperty != null &&
        data.recordProperty !== undefined &&
        data.recordProperty.Name === 'LineTotal'
      ) {
        if (this.sLines.filter((x) => x.LineType === 'S').length !== 0) {
          this.editSubTotalLine(data.line);
        }
      }

      if (this.section == null || this.section.ParentFields == null) {
        return;
      }
      const parentFields = this.section.ParentFields.split(';');
      if (
        parentFields.indexOf(
          `${data.sectionTagName}.${data.recordProperty.Name}`,
        ) === -1
      ) {
        return;
      }

      this.sectionLines.forEach((line) => {
        this.deleteRow(line.Id);
      });
    });

    this.scrollY =
      this.section.AdditionalInformationParsed.FixedHeader &&
      this.section.AdditionalInformationParsed.TableFixedHeight !== 0
        ? this.section.AdditionalInformationParsed.TableFixedHeight + 'px'
        : '10000px';
    //console.log('this.scrollY', this.scrollY);

    this.displayActionForLine =
      this.moduleStructure.buttons.filter(
        (button) =>
          button.SectionId == this.section.Id &&
          button.AdditionalInformationParsed.OnLineLevel,
      ).length !== 0;

    var deleteIsOutOfActionsForSections = g.deleteIsOutOfActionsFor.split(',');
    this.deleteIsOutOfActions =
      deleteIsOutOfActionsForSections.indexOf(this.section.XmlTagName) !== -1;

    this.enableMovingLineInUpdateMode = g.enableMovingLineInUpdateMode;

    var modulesToCheck = g.allowBulkLineCloseForModules.split(',');
    if (
      modulesToCheck.indexOf(this.moduleStructure.module.Id.toString()) !== -1
    ) {
      this.allowBulkLineClose = true;
    }
  }

  handleTableClick() {
    if (this.sectionLines.length === 0) {
      this.addLineToTable();
    }
  }

  prepareSectionLines() {
    if (this.workingWithLines === true) {
      return;
    }
    const result: any[] = [];
    const lines = this.recordCategory.Lines;
    const specialLines = this.recordCategory.SpecialLines
      ? this.recordCategory.SpecialLines
      : [];

    let specAdded = [];
    specialLines.forEach((specialLine, index) => {
      specialLine.Id = index + 10000;
      if (specialLine.AftLineNum !== -1) {
        return;
      }

      result.push(specialLine);
      specAdded.push(specialLine.Id);
    });

    lines.forEach((line) => {
      const index = line.Id;
      // NEW CHANGE
      // use id, because when linnum have gabs its not good.
      // Properties.find(
      //   (p) => p.Name === 'LineNum'
      // )?.ValueAsObject;

      let specialLinesToAdd = specialLines
        .filter((sl) => sl.AftLineNum !== -1 && sl.AftLineNum === index)
        .sort((a, b) => a.LineSeq - b.LineSeq);

      /*if (specialLinesToAdd.length === 0) {
        specialLinesToAdd = specialLines
          .filter((sl) => sl.AftLineNum === line.Id)
          .sort((a, b) => a.LineSeq - b.LineSeq);
      }*/

      result.push(line);

      specialLinesToAdd.forEach((s) => {
        specAdded.push(s.Id);
        result.push(s);
      });
    });

    specialLines
      .filter((x) => specAdded.indexOf(x.Id) === -1)
      .forEach((s) => {
        s.AftLineNum = this.recordCategory.Lines.length - 1;
        result.push(s);
      });

    this.recordCategoryLinesLength = this.recordCategory.Lines.length;
    this.recordCategorySpecialLinesLength =
      this.recordCategory.SpecialLines?.length;

    if (
      this.recordCategoryLinesLength === this.recordCategory.Lines.length &&
      this.recordCategorySpecialLinesLength ===
        this.recordCategory.SpecialLines?.length
    ) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.sectionLinesVal = [...result];
        this.cdr.detectChanges();
      }, 50);
    }

    setTimeout(() => {
      const parentElement = (this.nzTableComponent as any).elementRef
        .nativeElement;
      const tableBodyElement = parentElement.querySelector('.ant-table-body');

      if (tableBodyElement) {
        // Scroll the element to the bottom
        tableBodyElement.scrollTop =
          tableBodyElement.scrollHeight - tableBodyElement.clientHeight;
      }
    }, 500);
  }

  editRow(data: RecordLine, visible: boolean) {
    if (visible) {
      data.IsEditModeDrawerInitialized = true;
      setTimeout(() => {
        data.IsEditMode = true;
      }, 200);
    } else {
      data.IsEditMode = false;
      setTimeout(() => {
        data.IsEditModeDrawerInitialized = false;
      }, 50);
    }
  }

  getSpanVal(fieldKey: number): number {
    if (fieldKey === 3 || this.fieldGroupCount === 1) {
      return 24;
    } else {
      if (this.thereIsCenter) {
        return 8;
      } else {
        return 12;
      }
    }
  }

  getPushVal(fieldKey: number): number {
    if (this.fieldGroupCount === 1) {
      return 0;
    } else {
      if (this.thereIsCenter && fieldKey === 2) {
        return 8;
      } else {
        return 0;
      }
    }
  }

  getPullVal(fieldKey: number): number {
    if (this.fieldGroupCount === 1) {
      return 0;
    } else {
      if (this.thereIsCenter && fieldKey === 4) {
        return 8;
      } else {
        return 0;
      }
    }
  }

  prepareSectionFields() {
    this.fields = this.section.Fields.sort((a, b) => a.SortOrder - b.SortOrder);
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.moduleStructure.module.Sections.length; i++) {
      let section = this.moduleStructure.module.Sections[i];
      if (section.XmlTagName === this.section.XmlTagName) {
        section = this.section;
        break;
      }
    }

    this.fieldGroups = this.fields.reduce((acc, obj) => {
      let key = obj.PCAlignment;
      if (key === 0) {
        key = 1;
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    this.thereIsCenter =
      this.fields.filter((obj) => obj.PCAlignment === 4).length > 0;

    this.fieldGroupCount = Object.keys(this.fieldGroups).length;

    this.fieldGroupKeys = Object.keys(this.fieldGroups);

    for (const key of this.fieldGroupKeys) {
      this.fieldGroups[key] = this.fieldGroups[key].sort((field1, field2) => {
        return this.layoutService.compareObjects(field1, field2, 'SortOrder');
      });
    }
  }

  getTableWidth() {
    const fieldsToRender = this.getFieldsToRender();
    let result = 0;

    fieldsToRender.forEach((field: any) => {
      result += this.getFieldWith(field);
    });

    return result;
  }

  getFieldWith(field): number {
    if (
      field.AdditionalInformationParsed.Width === '' ||
      field.AdditionalInformationParsed.Width === undefined ||
      field.AdditionalInformationParsed.Width === 0
    ) {
      return 140;
    } else {
      return field.AdditionalInformationParsed.Width;
    }
  }

  getSectionCategory(): RecordCategory {
    let recordCategory: RecordCategory = null;
    this.recordModel.Categories.forEach((category) => {
      if (category.Id === this.section.XmlTagName) {
        recordCategory = category;
      }
    });

    if (recordCategory == null) {
      recordCategory = {
        Id: this.section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      this.recordModel.Categories.push(recordCategory);
    }
    return recordCategory;
  }

  addInterestedItem() {
    const interestedItemCat = this.parentRecordModel.Categories.find(
      (cat) => cat.Id === 'Interested_Items',
    );
    if (
      interestedItemCat !== undefined &&
      interestedItemCat != null &&
      interestedItemCat.Lines.length > 0
    ) {
      interestedItemCat.Lines.forEach((element) => {
        this.addLineToTable();

        const interestedItemCodeProp = element.Properties.find(
          (prop) => prop.Name === 'ItemCode',
        );
        const itemCodeProp = this.recordCategory.Lines[
          this.recordCategory.Lines.length - 1
        ].Properties.find((prop) => prop.Name === 'ItemCode');

        // itemCodeProp.ValueAsObject = interestedItemCodeProp.ValueAsObject;

        LayoutService.setValue(
          itemCodeProp,
          interestedItemCodeProp.ValueAsObject,
          this.layoutService,
          this.recordModel,
          this.recordCategory.Lines[this.recordCategory.Lines.length - 1].Id,
          this.section.XmlTagName,
          this.moduleStructure,
        );

        // this.layoutService.triggerFieldValueChanged({
        //   recordProperty: itemCodeProp,
        //   formId: '',
        //   line: this.lines[this.lines.length - 1].Id,
        //   recordModel: this.recordModel,
        //   sectionTagName: this.section.XmlTagName,
        //   moduleStructure: this.moduleStructure,
        // });

        const interestedItemNameProp = element.Properties.find(
          (prop) => prop.Name === 'ItemDescription',
        );
        const itemNameProp = this.recordCategory.Lines[
          this.recordCategory.Lines.length - 1
        ].Properties.find((prop) => prop.Name === 'ItemDescription');

        itemNameProp.ValueAsObject = interestedItemNameProp.ValueAsObject;
        this.layoutService.triggerFieldValueChanged({
          recordProperty: itemNameProp,
          formId: '',
          line: this.recordCategory.Lines[this.recordCategory.Lines.length - 1]
            .Id,
          recordModel: this.recordModel,
          sectionTagName: this.section.XmlTagName,
          moduleStructure: this.moduleStructure,
        });

        const interestedItemQtyProp = element.Properties.find(
          (prop) => prop.Name === 'Quantity',
        );
        const itemQtyProp = this.recordCategory.Lines[
          this.recordCategory.Lines.length - 1
        ].Properties.find((prop) => prop.Name === 'Quantity');

        itemQtyProp.ValueAsObject = interestedItemQtyProp.ValueAsObject;
        this.layoutService.triggerFieldValueChanged({
          recordProperty: itemQtyProp,
          formId: '',
          line: this.recordCategory.Lines[this.recordCategory.Lines.length - 1]
            .Id,
          recordModel: this.recordModel,
          sectionTagName: this.section.XmlTagName,
          moduleStructure: this.moduleStructure,
        });
      });
    }
  }

  addLineToTable() {
    /*if (g.userIdentity?.Area !== 1) {
      return;
    }*/
    let checkDates = g.checkDatesBeforeAddLinesToOrder;
    let headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'Documents',
    );

    if (headerCat != null && headerCat !== undefined) {
      let cardCode = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode',
      )?.ValueAsObject;

      if (
        this.recordModel.ObjectKey !== 'oPurchaseRequest' &&
        this.recordModel.ObjectKey !== 'BlanketAgreement' &&
        this.moduleStructure.module.Id !== 41 &&
        g.userIdentity?.Area === 1 &&
        (cardCode == null || cardCode === undefined || cardCode === '')
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>Please Select a Customer First</b>',
        );
        return;
      }
      if (this.recordModel.ObjectKey === 'oOrders' && checkDates) {
        let delvdate = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocDueDate',
        )?.ValueAsObject;

        let SON_DelDate = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'U_SON_DelDate',
        )?.ValueAsObject;

        console.log('delvdate>>', delvdate);
        console.log('SON_DelDate>>', SON_DelDate);
        if (SON_DelDate == null || delvdate == null) {
          this.notificationService.error(
            this.layoutService.translate('Error'),
            '<b>Please wait for system to finish loading data</b>',
          );
          return;
        }
      }
    }

    if (this.recordModel.ObjectKey === 'BlanketAgreement') {
      if (
        this.blanketAgreementStatus === 'A' ||
        this.blanketAgreementStatus === 'asApproved'
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>You cannot add items to "Approved" BlanketAgreement</b>',
        );
        return;
      }
    }

    RecordModel.addLineToTable(
      this.recordModel,
      this.section,
      this.recordCategory,
      this.defaultVals,
      this.lines,
      this.layoutService,
      this.moduleStructure,
      this.nzTableComponent,
    );
  }

  addLineBefore(index) {
    index = this.enablePaginationInLineSection
      ? (this.currentPage - 1) * this.pageSizeInLineSection + index
      : index;
    const base_row = this.sectionLines[index];

    const baseLine = this.recordCategory.Lines.find(
      (l) => l.Id === base_row.Id,
    );
    const baseLineIndex = this.recordCategory.Lines.indexOf(baseLine);
    const newLine = RecordLine.addNewLine(
      this.recordModel,
      this.section,
      undefined,
      this.moduleStructure.defaultValues,
      this.moduleStructure,
      this.layoutService,
      baseLineIndex,
    );

    this.prepareSectionLines();
  }

  importItemsFromFile() {
    const drawerRef = this.drawerService.create({
      nzTitle: this.layoutService.translate('Import Items'),
      nzContent: ImportDocItemsComponent,
      nzWrapClassName: 'drawer-size-2x',
      nzContentParams: {},
    });

    drawerRef.afterClose.subscribe(() => {
      drawerRef.getContentComponent().fieldsToImport;
      this.executeImportItemsFromFileData(
        drawerRef.getContentComponent().fieldsToImport,
        drawerRef.getContentComponent().itemsToImport,
      );
    });
  }

  executeImportItemsFromFileData(
    fieldsToImport: string[],
    itemsToImport: any[],
  ) {
    const doc = new businessDoc.Documents(
      this.layoutService,
      this.message,
      this.modalService,
      false,
    );

    console.log(fieldsToImport);
    console.log(itemsToImport);
    LayoutService.importMode = true;
    let shouldCalcPrice = false;
    let lineIds = [];
    let timeOutPeriod = 5000; // 1000 * itemsToImport.length;
    const productDataRequest: {
      newLine: RecordLine;
      childCode: any;
      field: Field;
      args: FieldValueChangedArgs;
      treeType: string;
    }[] = [];

    for (let index = 0; index < itemsToImport.length; index++) {
      let itemCodeIndex = fieldsToImport.findIndex((k) => k === 'ItemCode');
      let quantityIndex = fieldsToImport.findIndex((k) => k === 'Quantity');
      let descriptionIndex = fieldsToImport.findIndex(
        (k) => k === 'Description',
      );
      let priceIndex = fieldsToImport.findIndex((k) => k === 'UnitPrice');

      let itemCode = itemsToImport[index][itemCodeIndex];
      let quantity = itemsToImport[index][quantityIndex];
      let description = itemsToImport[index][descriptionIndex];
      let price = itemsToImport[index][priceIndex];

      this.addLineToTable();

      const lineToWorkOn =
        this.recordCategory.Lines[this.recordCategory.Lines.length - 1];

      lineIds.push(lineToWorkOn.Id);

      // Find existing properties
      const itemCodeProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'ItemCode',
      );
      const quantityProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'Quantity',
      );
      const priceProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'UnitPrice',
      );

      // Set Quantity
      if (quantityProp && quantity) {
        quantityProp.Value = quantity;
        quantityProp.ValueAsObject = quantity;

        LayoutService.setValue(
          quantityProp,
          quantity,
          this.layoutService,
          this.recordModel,
          lineToWorkOn.Id,
          'Document_Lines',
          this.moduleStructure,
          true,
        );
      }

      // (Optional) Set Price
      if (priceProp && price) {
        priceProp.Value = price;
        priceProp.ValueAsObject = price;
        priceProp.IgnoreAutoPrice = true;
      } else {
        shouldCalcPrice = true;
      }

      // Set ItemCode
      if (itemCodeProp) {
        itemCodeProp.Value = itemCode;
        itemCodeProp.ValueAsObject = itemCode;
        //itemCodeProp.ValidateValueForLinkedValue = true;
        LayoutService.setValue(
          itemCodeProp,
          itemCode,
          this.layoutService,
          this.recordModel,
          lineToWorkOn.Id,
          'Document_Lines',
          this.moduleStructure,
          true,
        );
        this.checkWarningOnChange(this.itemCodeField, lineToWorkOn);

        const itemNameProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'ItemDescription',
        );

        if (description) {
          itemNameProp.Value = description;
          itemNameProp.ValueAsObject = description;
          LayoutService.setValue(
            itemNameProp,
            description,
            this.layoutService,
            this.recordModel,
            lineToWorkOn.Id,
            'Document_Lines',
            this.moduleStructure,
            true,
          );
        } else {
          this.layoutService
            .executeQuery(2411, {
              'Document_Lines.ItemCode': itemCode,
            })
            .subscribe((result: any[]) => {
              if (result.length > 0) {
                if (
                  result[0].Value != null &&
                  result[0].Value !== undefined &&
                  result[0].Value !== ''
                ) {
                  itemNameProp.Value = result[0].Value;
                  itemNameProp.ValueAsObject = result[0].Value;
                  LayoutService.setValue(
                    itemNameProp,
                    result[0].Value,
                    this.layoutService,
                    this.recordModel,
                    lineToWorkOn.Id,
                    'Document_Lines',
                    this.moduleStructure,
                    true,
                  );
                }
              }
            });
        }
      }

      for (let index1 = 0; index1 < fieldsToImport.length; index1++) {
        let field = fieldsToImport[index1];
        if (
          field === 'ItemCode' ||
          field === 'Quantity' ||
          field === 'UnitPrice'
        ) {
          continue;
        }

        let fieldIndex = fieldsToImport.findIndex((k) => k === field);
        let fieldVal = itemsToImport[index][fieldIndex];
        const fieldProp = lineToWorkOn.Properties.find((p) => p.Name === field);

        if (fieldProp && fieldVal) {
          fieldProp.Value = fieldVal;
          fieldProp.ValueAsObject = fieldVal;

          LayoutService.setValue(
            fieldProp,
            fieldVal.toString(),
            this.layoutService,
            this.recordModel,
            lineToWorkOn.Id,
            'Document_Lines',
            this.moduleStructure,
            true,
          );
        }
      }

      productDataRequest.push({
        newLine: lineToWorkOn,
        childCode: itemCode,
        field: this.itemCodeField,
        args: {
          recordModel: this.recordModel,
          recordProperty: itemCodeProp,
          formId: '',
          line: lineToWorkOn.Id,
          sectionTagName: 'Document_Lines',
          moduleStructure: this.moduleStructure,
        },
        treeType: '',
      });
    }

    setTimeout(() => {
      LayoutService.importMode = false;

      if (!shouldCalcPrice) {
        for (let j = 0; j < lineIds.length; j++) {
          doc.Document_UpdateRowTotal({
            formId: this.recordModel.FormGUID,
            line: lineIds[j],
            moduleStructure: this.moduleStructure,
            recordModel: this.recordModel,
            recordProperty: undefined,
            sectionTagName: 'Document_Lines',
          });
        }
        setTimeout(() => {
          doc.oDocuments_TotalCalc(
            {
              formId: this.recordModel.FormGUID,
              line: 0,
              moduleStructure: this.moduleStructure,
              recordModel: this.recordModel,
              recordProperty: undefined,
              sectionTagName: 'Document_Lines',
            },
            true,
          );
        }, 2000);
      } else {
        lineIds.forEach((line) => {
          const lineToWork = this.recordCategory.Lines[line];
          const itemCodeArgs: FieldValueChangedArgs = {
            line: lineToWork.Id,
            moduleStructure: this.moduleStructure,
            formId: '',
            recordModel: this.recordModel,
            recordProperty: lineToWork.Properties.find(
              (p) => p.Name === 'ItemCode',
            ),
            sectionTagName: 'Document_Lines',
          };

          doc.updateRowPricesEvent(itemCodeArgs, false, true);
        });
      }
    }, timeOutPeriod);
  }

  importItemsFromTextArea() {
    /*if (g.userIdentity?.Area !== 1) {
      return;
    }*/
    let checkDates = g.checkDatesBeforeAddLinesToOrder;
    let headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'Documents',
    );

    if (headerCat != null && headerCat !== undefined) {
      let cardCode = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode',
      )?.ValueAsObject;

      if (
        this.recordModel.ObjectKey !== 'oPurchaseRequest' &&
        this.recordModel.ObjectKey !== 'BlanketAgreement' &&
        this.moduleStructure.module.Id !== 41 &&
        g.userIdentity?.Area === 1 &&
        (cardCode == null || cardCode === undefined || cardCode === '')
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>Please Select a Customer First</b>',
        );
        return;
      }

      if (this.recordModel.ObjectKey === 'oOrders' && checkDates) {
        let delvdate = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocDueDate',
        )?.ValueAsObject;

        let SON_DelDate = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'U_SON_DelDate',
        )?.ValueAsObject;

        console.log('delvdate>>', delvdate);
        console.log('SON_DelDate>>', SON_DelDate);
        if (SON_DelDate == null || delvdate == null) {
          this.notificationService.error(
            this.layoutService.translate('Error'),
            '<b>Please wait for system to finish loading data</b>',
          );
          return;
        }
      }
    }

    const items = this.itemsToImport.split('\n');
    const productDataRequest: {
      newLine: RecordLine;
      childCode: any;
      field: Field;
      args: FieldValueChangedArgs;
      treeType: string;
    }[] = [];

    this.itemsToImport = '';

    this.itemCodeField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'ItemCode',
    );

    const isNumeric = (val: string) => {
      return !isNaN(Number(val.trim())) && val.trim() !== '';
    };

    items.forEach((line) => {
      const trimmedLine = line.trim();
      if (!trimmedLine) {
        return; // Skip empty lines
      }

      // Split each line by tab
      const parts = trimmedLine.split('\t').map((p) => p.trim());
      if (parts.length === 0) {
        return;
      }

      // Variables to hold extracted values
      let itemCode = '';
      let quantity = '';
      let price = '';
      let description = '';
      let descriptionUsed = false; // Track if the second element was used as a description

      // 1) If array length >= 1 => first element is always itemCode
      itemCode = parts[0];

      // 2) If array length >= 2 => second element could be quantity if numeric, else description
      if (parts.length >= 2) {
        if (isNumeric(parts[1])) {
          quantity = parts[1];
        } else {
          description = parts[1];
          descriptionUsed = true; // We used second element as a description
        }
      }

      // 3) If array length >= 3 => third element logic depends on whether we used a description
      if (parts.length >= 3) {
        const third = parts[2];
        if (descriptionUsed) {
          // If the second element is a description, then the third element could be the quantity if numeric
          if (isNumeric(third)) {
            quantity = third;
          }
          // If it's not numeric, we just ignore it (per your rules)
        } else {
          // If the second element was quantity,
          // then the third might be a price if numeric
          if (isNumeric(third)) {
            price = third;
          }
          // Otherwise ignore it
        }
      }

      // 4) If array length == 4 => the fourth element is only used as a price if we used a description
      //    (i.e., if `descriptionUsed` is true). Otherwise ignore it.
      if (parts.length === 4) {
        const fourth = parts[3];
        if (descriptionUsed && isNumeric(fourth)) {
          price = fourth;
        }
        // Otherwise we ignore it
      }

      this.addLineToTable();

      const lineToWorkOn =
        this.recordCategory.Lines[this.recordCategory.Lines.length - 1];

      // Find existing properties
      const itemCodeProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'ItemCode',
      );
      const quantityProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'Quantity',
      );
      const priceProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'UnitPrice',
      );
      const discProp = lineToWorkOn.Properties.find(
        (p) => p.Name === 'DiscountPercent',
      );

      // Set Quantity
      if (quantityProp && quantity) {
        quantityProp.Value = quantity;
        quantityProp.ValueAsObject = quantity;

        LayoutService.setValue(
          quantityProp,
          quantity,
          this.layoutService,
          this.recordModel,
          lineToWorkOn.Id,
          'Document_Lines',
          this.moduleStructure,
          true,
        );
      }

      // (Optional) Set Price
      if (priceProp && price) {
        priceProp.Value = price;
        priceProp.ValueAsObject = price;
        priceProp.IgnoreAutoPrice = true;
        if (discProp !== undefined) {
          discProp.IgnoreAutoPrice = true;
        }
      }

      // Set ItemCode
      if (itemCodeProp) {
        itemCodeProp.Value = itemCode;
        itemCodeProp.ValueAsObject = itemCode;
        //itemCodeProp.ValidateValueForLinkedValue = true;
        LayoutService.setValue(
          itemCodeProp,
          itemCode,
          this.layoutService,
          this.recordModel,
          lineToWorkOn.Id,
          'Document_Lines',
          this.moduleStructure,
          true,
        );
        this.checkWarningOnChange(this.itemCodeField, lineToWorkOn);
      }

      productDataRequest.push({
        newLine: lineToWorkOn,
        childCode: itemCode,
        field: this.itemCodeField,
        args: {
          recordModel: this.recordModel,
          recordProperty: itemCodeProp,
          formId: '',
          line: lineToWorkOn.Id,
          sectionTagName: 'Document_Lines',
          moduleStructure: this.moduleStructure,
        },
        treeType: '',
      });
    });

    if (productDataRequest.length > 0) {
      this.layoutService.loadModuleData(4, productDataRequest, [], false, true);
    }
  }

  importItemsFromTextAreaHandleTab(event) {
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent focus from moving

      const textarea = event.target as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Insert tab character at the cursor position
      this.itemsToImport =
        this.itemsToImport.substring(0, start) +
        '\t' +
        this.itemsToImport.substring(end);

      // Update the cursor position after the tab
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1;
      }, 0);
    }
  }

  checkWarningOnChange(field, recordLine) {
    setTimeout(() => {
      let warningQueryIdToExecute =
        field.AdditionalInformationParsed.WarningMsgOnValueChangeQuery;
      if (warningQueryIdToExecute != null && warningQueryIdToExecute !== 0) {
        this.layoutService
          .getWarningMsgOnValueChange(
            this.recordModel,
            this.recordCategory,
            recordLine,
            warningQueryIdToExecute,
            field,
            this.moduleStructure,
          )
          .subscribe((result: any[]) => {
            if (result && result.length > 0) {
              let msg = result[0].Value;
              if (msg != null && msg !== undefined && msg !== '') {
                this.layoutService.notification.warning(
                  this.layoutService.translate('System Message'),
                  this.layoutService.translate(msg),
                  { nzDuration: 4000 },
                );
              }
            }
          });
      }
    }, 1500);
  }

  DuplicateLine(event, fromBulk: boolean = false): number {
    //console.log('xx');
    let addedLineId = -1;
    if (event !== undefined && event !== null) {
      if (
        event.Id !== undefined &&
        (event.LineType == null || event.LineType === undefined)
      ) {
        const newLine = JSON.parse(JSON.stringify(event));
        if (!newLine.Properties) {
          return;
        }

        let maxId = -1;
        this.recordCategory.Lines.forEach((line) => {
          if (line.Id > maxId) {
            maxId = line.Id;
          }
        });

        addedLineId = newLine.Id = maxId + 1; // this.lines.length;

        const lineNum = newLine.Properties.find((x) => x.Name === 'LineNum');
        if (lineNum) {
          lineNum.ValueAsObject = newLine.Id;
        }

        const itmLineNum = newLine.Properties.find(
          (x) => x.Name === 'U_ITM_LINENUM',
        );
        if (itmLineNum) {
          itmLineNum.ValueAsObject = newLine.Id;
        }

        this.recordCategory.Lines = [...this.recordCategory.Lines, newLine];

        this.recordCategory.MaxIndex++;

        const itemCodeEle = newLine.Properties.find(
          (prop) => prop.Name === 'ItemCode',
        );

        if (itemCodeEle != null && !fromBulk) {
          const _args: FieldValueChangedArgs = {
            recordModel: this.recordModel,
            recordProperty: itemCodeEle,
            formId: '',
            line: newLine.Id,
            sectionTagName: 'Document_Lines',
            moduleStructure: this.moduleStructure,
          };

          this.layoutService.triggerFieldValueChanged(_args);
        }
      } else if (event.LineSeq !== undefined) {
        this.addTextLineToTable(undefined);
        const newSLine = JSON.parse(JSON.stringify(event));
        // Object.assign(newSLine, event);
        // newSLine.LineSeq++;
        /*this.sLines.forEach((sline) => {
          if (sline.LineSeq > newSLine.LineSeq) {
            sline.LineSeq++;
          }
        });
        newSLine.LineSeq++;
        this.sLines = [...this.sLines, newSLine];*/
        this.sLines[this.sLines.length - 1].LineText = newSLine.LineText;
        //this.SpecialLinesInit();

        addedLineId = this.sLines[this.sLines.length - 1].Id;
      }
      // this.recordCategory.Lines = this.lines;
      this.recordCategory.SpecialLines = this.sLines;
      this.prepareSectionLines();

      this.layoutService.lineDuplicated.emit({
        recordLine:
          this.recordCategory.Lines[this.recordCategory.Lines.length - 1],
        moduleStructure: this.moduleStructure,
        section: this.section,
        recordModel: this.recordModel,
      });
    }

    return addedLineId;
  }

  AddNewSubTotalRow(row?) {
    /*if (g.userIdentity?.Area !== 1) {
      return;
    }*/

    let headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'Documents',
    );

    if (headerCat != null && headerCat !== undefined) {
      let cardCode = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode',
      )?.ValueAsObject;

      if (
        this.recordModel.ObjectKey !== 'oPurchaseRequest' &&
        this.recordModel.ObjectKey !== 'BlanketAgreement' &&
        this.moduleStructure.module.Id !== 41 &&
        g.userIdentity?.Area === 1 &&
        (cardCode == null || cardCode === undefined || cardCode === '')
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>Please Select a Customer First</b>',
        );
        return;
      }
    }

    const linesCategory = this.recordModel.Categories.find(
      (cat) => cat.Id === this.section.XmlTagName,
    );
    let afterLine = -1;
    if (row != null) {
      if (row.LineSeq != null) {
        afterLine = row.AftLineNum;
      } else if (row.Id != null) {
        const recordLine = row as RecordLine;
        if (
          recordLine.TreeTypeProp != null &&
          recordLine.TreeTypeProp.ValueAsObject === 'iSalesTree'
        ) {
          for (let i = recordLine.Id + 1; i < linesCategory.Lines.length; i++) {
            if (
              (linesCategory.Lines[i].TreeTypeProp.ValueAsObject ===
                'iIngredient' &&
                i === linesCategory.Lines.length - 1) ||
              linesCategory.Lines[i].TreeTypeProp.ValueAsObject !==
                'iIngredient'
            ) {
              afterLine = i;
              break;
            }
          }
        } else {
          afterLine = row.Properties.find(
            (p) => p.Name === 'LineNum',
          ).ValueAsObject;
        }
      }
    } else {
      if (linesCategory == null || linesCategory.Lines.length === 0) {
        afterLine = -1;
      } else {
        afterLine = linesCategory.Lines[
          linesCategory.Lines.length - 1
        ].Properties.find((p) => p.Name === 'LineNum').ValueAsObject;
      }
    }
    let specialRecordLine: SpecialLines = null;
    if (linesCategory.SpecialLines == null) {
      linesCategory.SpecialLines = [];
    }

    specialRecordLine = {
      LineSeq: linesCategory.SpecialLines.length,
      AftLineNum: afterLine,
      LineText: accounting.formatNumber(
        this.calculateSubtotal(row),
        g.companyConfiguration.AmountDecimal,
        g.companyConfiguration.ThousandSep,
        g.companyConfiguration.DecimalSep,
      ),
      LineType: 'S',
      IsNew: true,
      Id: 10000,
    };

    linesCategory.SpecialLines = [
      ...linesCategory.SpecialLines,
      specialRecordLine,
    ]; // .push();
    this.sLines = linesCategory.SpecialLines;
    this.updateSubtotals();
    this.prepareSectionLines();
  }

  editSubTotalLine(updatedLineId: number) {
    let total = 0;
    if (
      this.recordCategory.SpecialLines === undefined ||
      this.recordCategory.SpecialLines == null
    ) {
      return;
    }
    const specialLine = this.recordCategory.SpecialLines.find(
      (x) => x.AftLineNum >= updatedLineId && x.LineType === 'S',
    );

    if (specialLine == null) {
      return;
    }
    const test = this.recordCategory.SpecialLines.filter(
      (x) => x.LineSeq < specialLine.LineSeq,
    ).sort((a, b) => a.AftLineNum + b.AftLineNum)[0];
    const lastSpecialLine = this.recordCategory.SpecialLines.find(
      (x) => x.LineSeq < specialLine.LineSeq && x.LineType === 'S',
    );

    if (specialLine) {
      const lastAfterNum = lastSpecialLine ? lastSpecialLine.AftLineNum : -1;
      this.recordCategory.Lines.forEach((line) => {
        if (line.Id > lastAfterNum && line.Id <= specialLine.AftLineNum) {
          total += line.Properties.find(
            (x) => x.Name === 'LineTotal',
          ).ValueAsObject;
        }
      });
      specialLine.LineText = total.toString();
    }
    this.prepareSectionLines();
  }

  updateSubtotals() {
    const subtotalLines = this.recordCategory.SpecialLines.filter(
      (x) => x.LineType.toLowerCase() == 's',
    );
    subtotalLines.forEach((line) => {
      const row = {
        Id: line.AftLineNum,
      };
      line.LineText = accounting.formatNumber(
        this.calculateSubtotal(row),
        g.companyConfiguration.AmountDecimal,
        g.companyConfiguration.ThousandSep,
        g.companyConfiguration.DecimalSep,
      );
    });
  }

  calculateSubtotal(row?) {
    let lineId, maxAfterLineNum;
    const linesCategory = this.recordModel.Categories.find(
      (cat) => cat.Id === this.section.XmlTagName,
    );
    if (row == null) {
      row = linesCategory.Lines[linesCategory.Lines.length - 1];
    }
    const subTotalLines = this.sLines.filter((x) => x.LineType === 'S');
    if (subTotalLines.length > 0) {
      const lastSubtotals = subTotalLines
        .filter((x) => x.AftLineNum < row.Id)
        .sort((a, b) => a.AftLineNum - b.AftLineNum);
      if (lastSubtotals.length > 0) {
        const lastSubtotalLine =
          lastSubtotals[lastSubtotals.length - 1].AftLineNum;
        maxAfterLineNum = lastSubtotalLine;
      } else if (
        subTotalLines.filter((z) => z.AftLineNum > row.Id).length > 0
      ) {
        maxAfterLineNum = -1;
      } else {
        // maxAfterLineNum = subTotalLines[subTotalLines.length - 1].AftLineNum;
        maxAfterLineNum = -1;
      }
    } else {
      maxAfterLineNum = -1;
    }
    if (row != null && row !== undefined) {
      lineId = row.Id;
    } else {
      lineId = linesCategory.Lines[linesCategory.Lines.length - 1].Id;
    }

    let total = 0;
    linesCategory.Lines.forEach((line) => {
      if (line.Id <= lineId && line.Id > maxAfterLineNum) {
        if (
          line.Properties.find((prop) => prop.Name === 'LineType') ==
            undefined ||
          line.Properties.find((prop) => prop.Name === 'LineType')
            ?.ValueAsObject == 'R'
        ) {
          total += line.Properties.find(
            (x) => x.Name === 'LineTotal',
          ).ValueAsObject;
        }
      }
    });
    return total;
  }

  POTextLineChanged(event, data) {
    const line = this.recordCategory.Lines.find((x) => x.Id === data.Id);
    if (line != null) {
      line.Properties.find((x) => x.Name === 'LineText').ValueAsObject = event;
    }
  }

  addTextLineToTable(event?) {
    if (g.userIdentity?.Area !== 1) {
      return;
    }

    let headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'Documents',
    );

    if (headerCat != null && headerCat !== undefined) {
      let cardCode = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode',
      )?.ValueAsObject;

      if (
        this.recordModel.ObjectKey !== 'oPurchaseRequest' &&
        this.recordModel.ObjectKey !== 'BlanketAgreement' &&
        this.moduleStructure.module.Id !== 41 &&
        (cardCode == null || cardCode === undefined || cardCode === '')
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>Please Select a Customer First</b>',
        );
        return;
      }
    }

    let afterLine = -1;
    const linesCategory = this.recordModel.Categories.find(
      (cat) => cat.Id === this.section.XmlTagName,
    );

    const row = event?.row;
    const action = event?.action;
    //let lineGuid = '';
    if (row != null && row !== undefined) {
      if (row.LineSeq !== undefined) {
        afterLine = row.AftLineNum;
      } else if (row.Id !== undefined && event?.action === 'text_line_above') {
        const recordLine = row as RecordLine;
        if (recordLine.IsNew) {
          afterLine = linesCategory.Lines.findIndex(
            (l) => l.Id === recordLine.Id,
          );
          if (afterLine === 0) {
            afterLine = -1;
          } else {
            afterLine = linesCategory.Lines[afterLine - 1].Id;
          }
        } else {
          afterLine = recordLine.Id - 1;
        }
      } else if (row.Id !== undefined && event?.action === 'text_line_below') {
        const recordLine = row as RecordLine;
        // NEW CHANGE
        if (
          (recordLine.TreeTypeProp != null &&
            recordLine.TreeTypeProp.ValueAsObject === 'iSalesTree') ||
          recordLine.TreeTypeProp.ValueAsObject === 'S'
        ) {
          if (recordLine.IsNew) {
            afterLine = recordLine.Id;
            for (
              let i = recordLine.Id + 1;
              linesCategory.Lines.findIndex((l) => l.Id === i) <
              linesCategory.Lines.length;
              i++
            ) {
              const ingrediant =
                (linesCategory.Lines.findIndex((l) => l.Id === i) !== -1 &&
                  linesCategory.Lines.find((l) => l.Id === i).TreeTypeProp
                    .ValueAsObject == 'iIngredient') ||
                (linesCategory.Lines.findIndex((l) => l.Id === i) !== -1 &&
                  linesCategory.Lines.find((l) => l.Id === i).TreeTypeProp
                    .ValueAsObject == 'I');

              if (
                (ingrediant &&
                  linesCategory.Lines.findIndex((l) => l.Id === i) ===
                    linesCategory.Lines.length - 1) ||
                !ingrediant
              ) {
                //afterLine = i;
                afterLine = linesCategory.Lines.find((l) => l.Id === i - 1).Id;
                break;
              }
            }
          } else {
            for (
              let i = recordLine.Id + 1;
              i < linesCategory.Lines.length;
              i++
            ) {
              const ingrediant =
                linesCategory.Lines[i].TreeTypeProp.ValueAsObject ==
                  'iIngredient' ||
                linesCategory.Lines[i].TreeTypeProp.ValueAsObject == 'I';

              if (
                (ingrediant && i === linesCategory.Lines.length - 1) ||
                !ingrediant
              ) {
                //afterLine = i;
                afterLine = linesCategory.Lines[i - 1].Id;
                break;
              }
            }
          }
        } else {
          // NEW CHANGE
          afterLine = row.Id;
          // When we have gabs in LineNum sequence its problem to use LineNum, i think Id is better
          /*Properties.find(
            (p) => p.Name === 'LineNum'
          ).ValueAsObject;*/
        }
      }
    } else {
      if (linesCategory === undefined || linesCategory.Lines.length === 0) {
        afterLine = -1;
      } else {
        // NEW CHANGE
        afterLine = linesCategory.Lines[linesCategory.Lines.length - 1].Id;
        // When we have gabs in LineNum sequence its problem to use LineNum, i think Id is better
        //.Properties.find((p) => p.Name === 'LineNum').ValueAsObject;
      }
    }

    let specialRecordLine: SpecialLines = null;
    if (
      linesCategory.SpecialLines === undefined ||
      linesCategory.SpecialLines == null
    ) {
      linesCategory.SpecialLines = [];
    }

    /*if (afterLine !== -1) {
      lineGuid = linesCategory.Lines.find(
        (l) => l.Id === afterLine
      ).Properties.find((p) => p.Name === 'U_ITM_BWEB_LINE_GUID').ValueAsObject;
    }*/

    specialRecordLine = {
      LineSeq: linesCategory.SpecialLines.length, // recordCategory.Lines.length,
      AftLineNum: afterLine,
      LineText: '',
      LineType: 'T',
      IsNew: true,
      //LineGUID: lineGuid,
      Id:
        linesCategory.SpecialLines.length === 0
          ? 10000
          : linesCategory.SpecialLines[linesCategory.SpecialLines.length - 1]
              .Id + 1,
    };
    //LineGUID

    linesCategory.SpecialLines = [
      ...linesCategory.SpecialLines,
      specialRecordLine,
    ]; // .push();
    this.sLines = linesCategory.SpecialLines;
    this.recordCategory.SpecialLines = this.sLines;
    const specialLines = this.recordModel.Categories.find(
      (cat) => cat.Id === 'SpecialLines',
    );

    let recordLine: RecordLine = null;
    recordLine = {
      Id: 10000 + specialLines.Lines.length,
      MaxIndex: specialLines.Lines.length + 1,
      Properties: [],
    };

    let recordProperty: RecordProperties = {
      FieldName: 'AftLineNum',
      ValueAsObject: afterLine,
    };
    recordLine.Properties.push(recordProperty);
    recordProperty = {
      FieldName: 'LineSeq',
      ValueAsObject: linesCategory.SpecialLines.length,
    };
    recordLine.Properties.push(recordProperty);
    recordProperty = {
      FieldName: 'LineText',
      ValueAsObject: '',
    };
    recordLine.Properties.push(recordProperty);
    recordProperty = {
      FieldName: 'LineType',
      ValueAsObject: 'T',
    };
    recordLine.Properties.push(recordProperty);

    specialLines.Lines.push(recordLine);

    this.prepareSectionLines();
  }

  textLineChanged(id, text) {
    const specialLines = this.recordModel.Categories.find(
      (cat) => cat.Id === 'SpecialLines',
    );
    const line = specialLines.Lines.find((l) => l.Id === id);
    line.Properties.find((p) => p.FieldName === 'LineText').ValueAsObject =
      text;
  }
  PredefinedTextDrawer(textRow: SpecialLines) {
    this.textRowToAdd = textRow;
    RecordsListComponent.openRecordListDrawer(this.drawerService, {
      inDrawer: true,
      isSingleSelection: true,
      moduleId: 10001,
      parentComponent: this,
    });
  }

  selectionChanged(event) {
    console.log('selectionChanged', event);
  }

  submitSelection(event) {
    console.log('submitSelection', event);
    this.layoutService
      .getModuleHeaderData(10001, event, '', false)
      .subscribe((data: any) => {
        console.log(data);
        const sLine = this.sLines.find(
          (x) =>
            x.LineSeq === this.textRowToAdd.LineSeq &&
            x.LineType === this.textRowToAdd.LineType &&
            x.AftLineNum === this.textRowToAdd.AftLineNum,
        );
        sLine.LineText = data.Text as string;
        this.prepareSectionLines();
      });
  }

  newObjectCreated(event) {
    console.log('newObjectCreated', event);
  }

  deleteSpecialLine(id: number) {
    //#region update max subtotal index after deleting a subtotal line
    this.setOfCheckedId.clear();
    this.setOfCheckedIdFromParent.clear();
    const deletedLine = this.recordCategory.SpecialLines.find(
      (x) => x.LineSeq === id,
    );
    //#endregion

    this.recordCategory.SpecialLines = this.recordCategory.SpecialLines.filter(
      (p) => p.LineSeq !== id,
    );

    this.sLines = this.recordCategory.SpecialLines;

    let specialLines = this.recordModel.Categories.find(
      (c) => c.Id === 'SpecLines',
    );

    if (specialLines == null || specialLines === undefined) {
      specialLines = {
        Id: 'SpecLines',
        LineToDelete: '',
        KeyFieldName: 'LineNum',
        KeyPropertyName: 'LineNum',
        PropertyNameInParent: 'SpecialLines',
        Lines: [],
      };

      this.recordModel.Categories.push(specialLines);
    }

    if (
      specialLines.LineToDelete == null ||
      specialLines.LineToDelete === undefined
    ) {
      specialLines.LineToDelete = '';
    }

    if (specialLines.LineToDelete === '') {
      specialLines.LineToDelete += id;
    } else {
      specialLines.LineToDelete += ',' + id;
    }
    // let index = recordCategory.SpecialLines.findIndex((p) => p.LineSeq !== id);
    // recordCategory.SpecialLines.splice(index, 1);
  }

  getFieldsToRender(): any {
    this.section.Fields.forEach((field) => {
      if (field.AdditionalInformationParsed.VisibleInDialogOnly) {
        field.AdditionalInformationParsed.Visible = false;
      }

      /*
      if (
        field.AdditionalInformation !== undefined &&
        field.AdditionalInformation != null &&
        field.AdditionalInformation !== ''
      ) {
        const additionalInformation = JSON.parse(field.AdditionalInformation);
        if (
          additionalInformation.VisibleInDialogOnly !== undefined &&
          additionalInformation.VisibleInDialogOnly
        ) {
          field.AdditionalInformationParsed.Visible = false;
        }
      }*/
    });
    this.itemCodeField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'ItemCode',
    );

    this.quantityField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'Quantity',
    );
    if (
      this.recordModel.ObjectKey === 'InventoryCounting' ||
      this.recordModel.ObjectKey === 'InventoryPosting'
    ) {
      this.quantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'UoMCountedQuantity',
      );
      this.countedField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'Counted',
      );

      this.quantityFieldTitle = 'Counted Base Units';
    } else if (this.recordModel.ObjectKey === 'oPickLists') {
      this.quantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'PickedQuantity',
      );
      this.quantityFieldTitle = 'Picked';
    }
    this.openQuantityField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'OpenQty',
    );

    if (this.recordModel.ObjectKey === 'oPickLists') {
      this.openQuantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'ReleasedQuantity',
      );
      this.openQuantityFieldTitle = 'Released Quantity';
    }
    this.fromWarehouseField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'FromWarehouse',
    );
    this.warehouseCodeField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'WarehouseCode',
    );
    if (g.userIdentity?.Area !== 2) {
      return this.section.Fields.filter(
        (field) =>
          field.DataType !== 11 && field.AdditionalInformationParsed.Visible,
      ).sort((field1, field2) => {
        return this.layoutService.compareObjects(field1, field2, 'SortOrder');
      });
    } else {
      return this.section.Fields.filter(
        (field) =>
          field.DataType !== 11 &&
          field.AdditionalInformationParsed.Visible &&
          field.PortalStatus !== 1 &&
          field.PortalStatus !== 6,
      ).sort((field1, field2) => {
        return this.layoutService.compareObjects(field1, field2, 'SortOrder');
      });
    }
  }

  getSpecialFieldsToRender(): any {
    this.specialLineSection = this.moduleStructure.module.Sections.find(
      (sec) => sec.XmlTagName === 'SpecialLines',
    );
    if (this.specialLineSection === undefined) {
      return;
    }

    this.specialLineSection.Fields.forEach((field) => {
      if (
        field.AdditionalInformation !== undefined &&
        field.AdditionalInformation != null &&
        field.AdditionalInformation !== ''
      ) {
        const additionalInformation = JSON.parse(field.AdditionalInformation);
        if (
          additionalInformation.VisibleInDialogOnly !== undefined &&
          additionalInformation.VisibleInDialogOnly
        ) {
          field.AdditionalInformationParsed.Visible = false;
        }
      }
    });

    return this.specialLineSection.Fields.filter(
      (field) =>
        field.DataType !== 11 && field.AdditionalInformationParsed.Visible,
    ).sort((field1, field2) => {
      return this.layoutService.compareObjects(field1, field2, 'SortOrder');
    });
  }

  getHiddenFields(): any {
    this.section.Fields.forEach((field) => {
      if (
        field.AdditionalInformation !== undefined &&
        field.AdditionalInformation != null &&
        field.AdditionalInformation !== ''
      ) {
        const additionalInformation = JSON.parse(field.AdditionalInformation);
        if (
          additionalInformation.VisibleInDialogOnly !== undefined &&
          additionalInformation.VisibleInDialogOnly
        ) {
          field.AdditionalInformationParsed.Visible = false;
        }
      }
    });

    return this.section.Fields.filter(
      (field) =>
        field.DataType === 11 || !field.AdditionalInformationParsed.Visible,
    );
  }

  deleteSectionRow(data: any, bulkDelete = false) {
    this.setOfCheckedId.clear();
    this.setOfCheckedIdFromParent.clear();
    if (data.LineType !== 'S' && data.LineType !== 'T') {
      this.deleteRow(data.Id, bulkDelete);
    } else {
      this.deleteSpecialLine(data.LineSeq);
    }
  }

  deleteConfirm(data: any): void {
    this.modalService.confirm({
      nzTitle: this.layoutService.translate('Are you sure delete this line?'),
      nzOkText: this.layoutService.translate('Yes'),
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.deleteRow(data.Id),
      nzCancelText: this.layoutService.translate('No'),
    });
  }

  deleteRow(id: number, bulkDelete = false): void {
    this.setOfCheckedId.clear();
    this.setOfCheckedIdFromParent.clear();
    if (this.section.XmlTagName === 'BWEBAttachments') {
      let dltLines = this.recordModel.Categories.find(
        (x) => x.Id === 'BWEBAttachments',
      ).DeletedLines;
      if (dltLines != null) {
        const lineToDelete = this.recordCategory.Lines[id];
        dltLines = [...dltLines, lineToDelete];
      }
    }
    RecordModel.deleteLine(
      id,
      this.recordModel,
      this.section,
      this.layoutService,
      this.moduleStructure,
      (recordLine) => {
        this.deletedLines.push(recordLine);
      },
      (lineToDeleteIndex) => {
        this.editSubTotalLine(
          this.recordCategory.Lines[
            lineToDeleteIndex === 0 ? 0 : lineToDeleteIndex - 1
          ].Id,
        );
      },
      (lines) => {
        this.recordCategory.Lines = lines;
      },
      bulkDelete,
    );

    this.layoutService.lineDuplicated.emit({
      recordLine:
        this.recordCategory.Lines[this.recordCategory.Lines.length - 1],
      moduleStructure: this.moduleStructure,
      section: this.section,
      recordModel: this.recordModel,
    });
  }

  SpecialLinesInit() {
    this.recordCategory.SpecialLines = [];
    this.specialLinesData = [];
    if (this.recordModel !== undefined) {
      const specialLines = this.recordModel.Categories.find(
        (cat) => cat.Id === 'SpecialLines',
      );
      if (specialLines !== undefined) {
        specialLines.Lines = specialLines.Lines.filter(
          (x) =>
            x.Properties.find((x) => x.FieldName === 'LineType')
              .ValueAsObject != null,
        );
        this.specialLinesData = specialLines.Lines;
        specialLines.Lines.forEach((element, index) => {
          const line: SpecialLines = {
            AftLineNum: element.Properties.find(
              (p) => p.FieldName === 'AftLineNum',
            ).ValueAsObject,
            LineSeq: element.Properties.find((p) => p.FieldName === 'LineSeq')
              .ValueAsObject,
            LineText: element.Properties.find((p) => p.FieldName === 'LineText')
              .ValueAsObject,
            LineType: element.Properties.find((x) => x.FieldName === 'LineType')
              .ValueAsObject,
            Id: 10000 + index,
          };

          this.recordCategory.SpecialLines.push(line);
        });
        this.sLines = this.recordCategory.SpecialLines;
      }
    }
  }

  MoveRowDown(row: any, index): boolean {
    this.updateCheckedSet(row.Id, index, true);
    this.moveLinesDown();
    this.updateSubtotals();
    //this.setOfCheckedId.clear();
    //this.setOfCheckedIdFromParent.clear();
    return;
    const lines = this.sectionLines.filter((x) => x.Id !== undefined);
    const sLines = this.sectionLines.filter((x) => x.LineSeq !== undefined);
    if (
      row.Id === lines[lines.length - 1].Id &&
      lines.filter((x) => x.AftLineNum === row.Id).length === 0
    ) {
      return;
    } else {
      //this.checkLines();
      /*if (this.isBomExists) {
        this.message.error(
          'Action is not supported for documents containing the "Sales BOM" type'
        );
      } else*/ {
        if (row.Id != null) {
          const specialLineAfter = sLines.find((x) => x.AftLineNum === row.Id);
          if (specialLineAfter) {
            specialLineAfter.AftLineNum--;
            this.editSubTotalLine(specialLineAfter.AftLineNum);
            this.editSubTotalLine(row.Id);
          } else {
            const rowAfter = lines.find((x) => x.Id === row.Id + 1);
            if (rowAfter === undefined) {
              return false;
            }
            this.rowPlus(row);
            this.rowMinus(rowAfter);
          }
        } else if (row.LineSeq != null) {
          this.sLinePlus(row);
          const LineBeforeRow = this.sectionLines[row.AftLineNum + 1];
          if (
            row.LineType != null &&
            row.LineType === 'S' &&
            LineBeforeRow != null &&
            LineBeforeRow.Id != null
          ) {
            // this.editSubTotalLine(LineBeforeRow.Id);
            this.updateSubtotals();
          }
        }
      }
      this.lines = this.sectionLines
        .filter((x) => x.Id != null)
        .sort((a, b) => a.Id - b.Id);
      this.sLines = this.sectionLines
        .filter((x) => x.LineSeq != null)
        .sort((a, b) => a.LineSeq - b.LineSeq);
      this.recordCategory.Lines = this.lines;
      this.recordCategory.SpecialLines = this.sLines;
    }

    this.prepareSectionLines();
    return true;
  }

  MoveRowUp(row: any, index, checkBom = true): boolean {
    this.updateCheckedSet(row.Id, index, true);
    this.moveLinesUp();
    this.updateSubtotals();
    //this.setOfCheckedId.clear();
    //this.setOfCheckedIdFromParent.clear();
    return;

    const lines = this.sectionLines.filter((x) => x.Id != null);
    const sLines = this.sectionLines.filter((x) => x.LineSeq != null);
    /*if (checkBom) {
      this.checkLines();
    }*/
    /*if (this.isBomExists) {
      this.message.error(
        'Action is not supported for documents containing the "Sales BOM" type'
      );
    } else*/ {
      const rowIndex = lines.indexOf(row);
      const lastLineNum = lines[rowIndex - 1];
      if (row.Id !== undefined) {
        const specialLineBefor = sLines.find(
          (x) => x.AftLineNum === lastLineNum.Id,
        );
        if (specialLineBefor) {
          specialLineBefor.AftLineNum = row.Id;
          this.editSubTotalLine(specialLineBefor.AftLineNum);
          this.editSubTotalLine(row.Id);
        } else {
          const rowBefore = lines.find((x) => x.Id === row.Id - 1);
          if (rowBefore === undefined) {
            return false;
          }
          this.rowMinus(row);
          this.rowPlus(rowBefore);
        }
      } else if (row.LineSeq !== undefined) {
        this.sLineMinus(row);
        const LineBeforeRow = this.sectionLines[row.AftLineNum];
        if (
          row.LineType !== undefined &&
          row.LineType === 'S' &&
          LineBeforeRow != null &&
          LineBeforeRow !== undefined &&
          LineBeforeRow.Id !== undefined
        ) {
          this.editSubTotalLine(LineBeforeRow.Id);
        } else if (
          row.LineType !== undefined &&
          row.LineType === 'S' &&
          LineBeforeRow == null &&
          LineBeforeRow === undefined
        ) {
          row.LineText = '0';
        }
      }
    }
    this.lines = this.sectionLines
      .filter((x) => x.Id !== undefined)
      .sort((a, b) => a.Id - b.Id);
    this.sLines = this.sectionLines
      .filter((x) => x.LineSeq !== undefined)
      .sort((a, b) => a.LineSeq - b.LineSeq);
    this.recordCategory.Lines = this.lines;
    this.recordCategory.SpecialLines = this.sLines;

    this.prepareSectionLines();
    return true;
  }

  checkLines() {
    this.lines.forEach((line) => {
      if (
        line.TreeTypeProp.ValueAsObject === 'iIngredient' ||
        line.TreeTypeProp.ValueAsObject === 'I' ||
        line.TreeTypeProp.ValueAsObject === 'iSalesTree'
      ) {
        this.isBomExists = true;
        return;
      }
    });
  }

  moveLinesUp() {
    if (
      !this.enableMovingLineInUpdateMode &&
      this.recordModel.EventType === EventType.Update
    ) {
      this.message.warning(
        'Move up and down are only available in creation mode.',
      );
      return;
    }

    let anyMoved = false;

    // Map line IDs to their current indices for quick lookup
    let idToIndexMap = new Map<number, number>();
    this.sectionLines.forEach((line, idx) => {
      if (line.Id != null) {
        idToIndexMap.set(line.Id, idx);
      }
    });

    // Collect selected line IDs
    let selectedIds = Array.from(this.setOfCheckedId);

    // Sort selected IDs based on their current index positions
    selectedIds.sort((a, b) => idToIndexMap.get(a)! - idToIndexMap.get(b)!);

    // Group selected lines into contiguous blocks
    let groups: any[][] = [];
    let group: any[] = [];
    for (let id of selectedIds) {
      let index = idToIndexMap.get(id)!;
      let line = this.sectionLines[index];

      if (group.length === 0) {
        // Start a new group
        group.push(line);
      } else {
        // Check if the current line is contiguous with the previous
        let prevId = group[group.length - 1]?.Id;
        let prevIndex = idToIndexMap.get(prevId)!;
        if (index === prevIndex + 1) {
          group.push(line);
        } else {
          // Non-contiguous, start a new group
          groups.push(group);
          group = [line];
        }
      }
    }
    if (group.length > 0) {
      groups.push(group);
    }

    // Process each group
    for (let grp of groups) {
      // Attempt to move the group up
      let moved = this.performMoveLinesUp(grp);
      if (moved) {
        anyMoved = true;
      }
    }

    if (!anyMoved) {
      // Inform the user that no lines were moved
      this.message.info('No lines were moved.');
    }

    // Since IDs are used for selection and IDs don't change, selection remains accurate
    // Refresh or prepare the lines for display
    this.prepareSectionLines();
  }

  performMoveLinesUp(linesToMove: any[]): boolean {
    if (linesToMove.length === 0) {
      return false;
    }

    const firstLine = linesToMove[0];
    let currentIndex = this.sectionLines.indexOf(firstLine);

    if (currentIndex <= 0) {
      // Cannot move up if already at the top
      return false;
    }

    // Determine the target index where we can insert the lines without breaking the hierarchy
    let targetIndex = currentIndex - 1;

    // Move past any preceding child lines to avoid breaking their hierarchy
    while (targetIndex >= 0) {
      const prevLine = this.sectionLines[targetIndex];
      const prevLineIsChild =
        prevLine.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
        prevLine.TreeTypeProp?.ValueAsObject === 'I';

      if (prevLineIsChild) {
        // Part of another group, keep moving back
        targetIndex--;
      } else {
        // Found a line that is not a child, stop here
        break;
      }
    }

    if (targetIndex < 0) {
      targetIndex = 0;
    }

    // Remove the lines from their current position
    this.sectionLines.splice(currentIndex, linesToMove.length);

    // Adjust the target index if necessary after removal
    if (currentIndex > targetIndex) {
      // No adjustment needed
    } else {
      targetIndex -= linesToMove.length;
      if (targetIndex < 0) targetIndex = 0;
    }

    // Insert the lines at the target index
    this.sectionLines.splice(targetIndex, 0, ...linesToMove);

    // Update the internal data structures if necessary
    this.updateAfterMovingLines();

    return true;
  }

  moveLinesDown(forceMoving = false, newBomItem = false) {
    if (
      !this.enableMovingLineInUpdateMode &&
      this.recordModel.EventType === EventType.Update &&
      !forceMoving
    ) {
      this.message.warning(
        'Move up and down are only available in creation mode.',
      );
      return;
    }

    let anyMoved = false;

    // Map line IDs to their current indices for quick lookup
    let idToIndexMap = new Map<number, number>();
    this.sectionLines.forEach((line, idx) => {
      if (line.Id != null) {
        idToIndexMap.set(line.Id, idx);
      }
    });

    // Collect selected line IDs
    let selectedIds = Array.from(this.setOfCheckedId);

    // Sort selected IDs based on their current index positions (from top to bottom)
    selectedIds.sort((a, b) => idToIndexMap.get(a)! - idToIndexMap.get(b)!);

    // Group selected lines into contiguous blocks
    let groups: any[][] = [];
    let group: any[] = [];
    for (let i = 0; i < selectedIds.length; i++) {
      let id = selectedIds[i];
      let index = idToIndexMap.get(id)!;
      let line = this.sectionLines[index];

      if (group.length === 0) {
        // Start a new group
        group.push(line);
      } else {
        // Check if the current line is contiguous with the next line
        let prevId = selectedIds[i - 1];
        let prevIndex = idToIndexMap.get(prevId)!;
        if (index === prevIndex + 1) {
          // Lines are contiguous
          group.push(line);
        } else {
          // Non-contiguous, start a new group
          groups.push(group);
          group = [line];
        }
      }
    }
    if (group.length > 0) {
      groups.push(group);
    }

    // Process each group from bottom to top
    // Since we're moving down, we process groups starting from the last group
    for (let i = groups.length - 1; i >= 0; i--) {
      let grp = groups[i];
      // Attempt to move the group down
      let moved = this.performMoveLinesDown(grp, newBomItem);
      if (moved) {
        anyMoved = true;
      }
    }

    if (!anyMoved) {
      // Inform the user that no lines were moved
      this.message.info('No lines were moved.');
    }

    // Since IDs are used for selection and IDs don't change, selection remains accurate
    // Refresh or prepare the lines for display
    this.prepareSectionLines();
  }

  performMoveLinesDown(linesToMove: any[], newBomItem): boolean {
    if (linesToMove.length === 0) {
      return false;
    }

    // Get the starting and ending indices of the lines to move
    let startIndex = this.sectionLines.indexOf(linesToMove[0]);
    let endIndex = this.sectionLines.indexOf(
      linesToMove[linesToMove.length - 1],
    );

    if (endIndex >= this.sectionLines.length - 1) {
      // Cannot move down if already at the bottom
      return false;
    }

    // Determine the target index where we can insert the lines
    let targetIndex = endIndex + 1;

    // Adjust targetIndex to skip over any following parent-child groups
    while (targetIndex < this.sectionLines.length) {
      const nextLine = this.sectionLines[targetIndex];
      const nextLineIsChild =
        nextLine.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
        nextLine.TreeTypeProp?.ValueAsObject === 'I';
      const nextLineIsParent =
        nextLine.TreeTypeProp?.ValueAsObject === 'iSalesTree' ||
        nextLine.TreeTypeProp?.ValueAsObject === 'S';
      const nextLineIsNormal =
        nextLine.TreeTypeProp?.ValueAsObject === 'iNotATree' ||
        nextLine.TreeTypeProp?.ValueAsObject === 'N';

      if ((nextLineIsNormal || nextLineIsParent) && newBomItem) {
        break;
      }
      if (nextLineIsChild) {
        // Part of another group, keep moving forward
        targetIndex++;
      } else if (nextLineIsParent) {
        // Skip over the entire parent-child group
        targetIndex++;

        // Skip over this parent's children
        while (targetIndex < this.sectionLines.length) {
          const followingLine = this.sectionLines[targetIndex];
          const followingLineIsChild =
            followingLine.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
            followingLine.TreeTypeProp?.ValueAsObject === 'I';

          if (followingLineIsChild) {
            targetIndex++;
          } else {
            break;
          }
        }
        break;
      } else {
        // Found a line that is not a child or parent, stop here
        targetIndex++;
        break;
      }
    }

    // Remove the lines from their current position
    this.sectionLines.splice(startIndex, linesToMove.length);

    // Adjust the target index if necessary after removal
    if (startIndex < targetIndex) {
      // Since we've removed lines above the target index, it shifts up
      targetIndex -= linesToMove.length;
    }

    // Insert the lines at the target index
    this.sectionLines.splice(targetIndex, 0, ...linesToMove);

    // Update the internal data structures if necessary
    this.updateAfterMovingLines();

    return true;
  }

  updateAfterMovingLines() {
    // Before updating Line.Id, create a mapping from old Line.Id to Line object
    const oldIdToLineMap = new Map<number, any>();
    this.sectionLines.forEach((line) => {
      oldIdToLineMap.set(line.Id, line);
    });

    // Store the selected lines based on old Line.Id
    const selectedLines = Array.from(this.setOfCheckedId).map((id) =>
      oldIdToLineMap.get(id),
    );

    // Update Line.Id to match the new index in sectionLines
    let normalLinesIndex = 0;
    let specialLinesIndex = 0;
    this.sectionLines.forEach((line, index) => {
      if (line.Properties) {
        line.Id = normalLinesIndex++;
        const visOrder = line.Properties.find((p) => p.Name === 'VisOrder');
        const itmlineNum = line.Properties.find(
          (p) => p.Name === 'U_ITM_LINENUM',
        );
        const lineNum = line.Properties.find((p) => p.Name === 'LineNum');
        if (visOrder != null) {
          visOrder.ValueAsObject = line.Id;
          visOrder.Value = line.Id;
        }
        if (lineNum != null) {
          lineNum.ValueAsObject = line.Id;
          lineNum.Value = line.Id;
        }
        if (itmlineNum != null) {
          itmlineNum.ValueAsObject = line.Id;
          itmlineNum.Value = line.Id;
        }
      } else {
        line.Id = 10000 + specialLinesIndex++;
        if (index === 0) {
          line.AftLineNum = -1;
        } else {
          const prevLine = this.sectionLines[index - 1];
          if (prevLine.Properties) {
            const realLineNum = prevLine.Properties.find(
              (p) => p.Name === 'LineNum',
            );
            line.AftLineNum = realLineNum.ValueAsObject;
          } else {
            line.AftLineNum = prevLine.AftLineNum;
          }
        }
      }
    });

    // Rebuild the lines and special lines arrays based on the new order
    this.lines = this.sectionLines.filter((x) => x.LineSeq == null);
    this.sLines = this.sectionLines.filter((x) => x.LineSeq != null);
    for (let index = 0; index < this.sLines.length; index++) {
      const element = this.sLines[index];
      element.LineSeq = index;
    }

    // Update the record category
    this.recordCategory.Lines = this.lines;
    this.recordCategory.SpecialLines = this.sLines;

    // Update the selection IDs to reflect the new Line.Id values
    const newSelectedIds = new Set<number>();
    selectedLines.forEach((line) => {
      if (line && line.Id != null) {
        newSelectedIds.add(line.Id);
      }
    });
    this.setOfCheckedId = newSelectedIds;

    // Prepare the lines for display
    this.prepareSectionLines();
  }

  addOrUpdate(id: number, fromParent: boolean): void {
    // find existing item
    let existingItem: { id: number; fromParent: boolean } | undefined;

    for (const item of this.setOfCheckedIdFromParent) {
      if (item.id === id) {
        existingItem = item;
        break;
      }
    }

    // remove old entry if found
    if (existingItem) {
      this.setOfCheckedIdFromParent.delete(existingItem);
    }

    // add updated entry
    this.setOfCheckedIdFromParent.add({ id, fromParent });
  }

  DeleteLines() {
    //console.log(this.setOfCheckedId);
    //console.log(this.setOfCheckedIdFromParent);

    let idToIndexMap = new Map<number, number>();
    this.sectionLines.forEach((line, idx) => {
      if (line.Id != null) {
        idToIndexMap.set(line.Id, idx);
      }
    });

    let selectedIds = Array.from(this.setOfCheckedId);
    selectedIds.sort((a, b) => idToIndexMap.get(a)! - idToIndexMap.get(b)!);

    let proceedToDelete = true;

    for (let id of selectedIds) {
      let index = idToIndexMap.get(id)!;
      let line = this.sectionLines[index];
      const item = [...this.setOfCheckedIdFromParent].find((x) => x.id === id);
      const fromParent = item.fromParent;

      if (
        line.TreeTypeProp !== undefined &&
        (line.TreeTypeProp.ValueAsObject === 'iIngredient' ||
          line.TreeTypeProp.ValueAsObject === 'I') &&
        !fromParent
      ) {
        /*this.message.error(
          'Cant delete Component, which was not released to WMS, Please delete complete Kit Item'
        );*/
        proceedToDelete = false;
        break;
      }
    }

    if (!proceedToDelete) {
      this.message.error(
        'Cant delete Component, which was not released to WMS, Please delete complete Kit Item',
      );
      return;
    }
    if (proceedToDelete) {
      this.bulkDeleteActivated = true;
      for (let id of selectedIds) {
        let index = idToIndexMap.get(id)!;
        let line = this.sectionLines[index];

        if (line != null && line !== undefined) {
          this.deleteSectionRow(line, true);
        }
      }
    }

    // it exist in the RecordMode.deleteline
    for (let i = 0; i < this.recordCategory.Lines.length; i++) {
      this.recordCategory.Lines[i].Id = i;
    }
    this.bulkDeleteActivated = false;
  }

  CloseLines() {
    //console.log(this.setOfCheckedId);
    //console.log(this.setOfCheckedIdFromParent);

    let idToIndexMap = new Map<number, number>();
    this.sectionLines.forEach((line, idx) => {
      if (line.Id != null) {
        idToIndexMap.set(line.Id, idx);
      }
    });

    let selectedIds = Array.from(this.setOfCheckedId);
    selectedIds.sort((a, b) => idToIndexMap.get(a)! - idToIndexMap.get(b)!);

    let proceedToClose = true;

    for (let id of selectedIds) {
      let index = idToIndexMap.get(id)!;
      let line = this.sectionLines[index];
      const item = [...this.setOfCheckedIdFromParent].find((x) => x.id === id);
      const fromParent = item.fromParent;

      if (
        line.TreeTypeProp !== undefined &&
        (line.TreeTypeProp.ValueAsObject === 'iIngredient' ||
          line.TreeTypeProp.ValueAsObject === 'I') &&
        !fromParent
      ) {
        /*this.message.error(
          'Cant delete Component, which was not released to WMS, Please delete complete Kit Item'
        );*/
        proceedToClose = false;
        break;
      }
    }

    if (!proceedToClose) {
      this.message.error(
        'Cant Close Component, Please close complete Kit Item',
      );
      return;
    }
    if (proceedToClose) {
      this.modalService.confirm({
        nzTitle: this.layoutService.translate('Are you sure?'),
        nzOkText: this.layoutService.translate('Yes'),
        nzCancelText: this.layoutService.translate('No'),
        nzAutofocus: 'cancel',
        nzOnOk: () => {
          this.closingLines = true;
          RecordModel.ExecuteCustomAction(
            `${this.moduleStructure.module.TableName}_CLOSE_LINES`,
            this.layoutService,
            this.recordModel,
            this.section.XmlTagName + '|' + selectedIds.join(','),
            this.moduleStructure,
            this.drawerService,
            this,
            '',
            this.router,
            () => {
              this.closingLines = false;
            },
          );
        },
      });
    }
  }

  reloadModel() {
    this.parentComponent.isLoading = true;
    this.parentComponent.moduleStructure = undefined;
    this.parentComponent.recordModel = undefined;
    this.parentComponent.ngOnInit();
  }

  DuplicateLines() {
    let component = this;
    //let sortedArray = Array.from(this.setOfCheckedId).sort((a, b) => a - b);
    this.afterLineNum = -1;
    this.linesList = [];
    let index = 1;
    let visualIndex = 1;
    this.sectionLines.forEach((line) => {
      if (!line.Properties) {
        visualIndex++;
        return;
      }

      let itemCodeProp = line.Properties.find(
        (prop) => prop.Name === 'ItemCode',
      );

      if (
        !(
          line.TreeTypeProp.ValueAsObject === 'iIngredient' ||
          line.TreeTypeProp.ValueAsObject === 'I'
        )
      ) {
        //let lineNumProp = line.Properties.find((prop) => prop.Name === 'LineNum');
        this.linesList.push({
          Name: visualIndex + ' - ' + itemCodeProp.ValueAsObject,
          LineNum: index,
          VIndex: visualIndex,
        });
        index++;
      }
      visualIndex++;
    });

    /*for (let id of this.setOfCheckedId) {
      let row = component.sectionLines[id];
      component.DuplicateLine(row);
    }

    this.setOfCheckedId.forEach(function (id) {
      component.updateCheckedSet(id, false);
    });*/

    this.listOfLinesVisible = true;
  }

  handleOk(): void {
    this.listOfLinesVisible = false;
    let component = this;
    let lengthBefore = this.sectionLines.length;

    // Map line IDs to their current indices for quick lookup
    let idToIndexMap = new Map<number, number>();
    this.sectionLines.forEach((line, idx) => {
      if (line.Id != null) {
        idToIndexMap.set(line.Id, idx);
      }
    });

    // Collect selected line IDs
    let selectedIds = Array.from(this.setOfCheckedId);

    // Sort selected IDs based on their current index positions
    selectedIds.sort((a, b) => idToIndexMap.get(a)! - idToIndexMap.get(b)!);

    let sortedArray: number[] = [];
    for (let id of selectedIds) {
      let index = idToIndexMap.get(id)!;
      sortedArray.push(index);
    }

    this.setOfCheckedId.clear();
    this.setOfCheckedIdFromParent.clear();
    this.workingWithLines = true;
    for (let id of sortedArray) {
      let row = component.sectionLines[id];
      const addedLine = component.DuplicateLine(row, true);
      if (addedLine) {
        this.setOfCheckedId.add(addedLine);
      }
    }

    this.workingWithLines = false;
    this.prepareSectionLines();

    setTimeout(() => {
      if (
        this.linesList.length > this.afterLineNum &&
        this.afterLineNum != -1
      ) {
        let extraStep = 0;
        const tempRow = this.linesList.find(
          (l) => l.LineNum === this.afterLineNum,
        );
        for (
          let index = tempRow.VIndex - 1;
          index < this.sectionLines.length;
          index++
        ) {
          const element = this.sectionLines[index];
          if (element.AftLineNum != null && element.AftLineNum !== undefined) {
            if (!this.setOfCheckedId.has(element.Id)) {
              extraStep += 1;
            }
          }
        }

        let maximumMovements = this.linesList.length + extraStep;
        while (this.afterLineNum < maximumMovements) {
          this.moveLinesUp();
          maximumMovements--;
        }
      }
      this.setOfCheckedId.clear();
      this.setOfCheckedIdFromParent.clear();
    }, 1500);
  }

  handleCancel(): void {
    this.listOfLinesVisible = false;
  }

  currentPage = 1;
  onItemChecked(id: number, index: number, checked: boolean): void {
    /*const row = this.recordCategory.Lines[id];
    if (
      row.Properties.find((x) => x.Name === 'U_ITM_LINENUM') !== undefined &&
      row.Properties.find((x) => x.Name === 'U_ITM_LINENUM') !== null
    ) {
      this.updateCheckedSet(
        row.Properties.find((x) => x.Name === 'U_ITM_LINENUM').ValueAsObject,
        checked
      );
    } else {*/
    this.updateCheckedSet(id, index, checked);
    //}
  }

  updateCheckedSet(
    id: number,
    index: number,
    checked: boolean,
    fromParent = false,
  ): void {
    index = this.enablePaginationInLineSection
      ? (this.currentPage - 1) * this.pageSizeInLineSection + index
      : index;
    if (checked) {
      this.setOfCheckedId.add(id);
      if (fromParent) {
        //this.setOfCheckedIdFromParent.add({ id, fromParent: true });
        this.addOrUpdate(id, true);
      } else {
        //this.setOfCheckedIdFromParent.add({ id, fromParent: false });
        this.addOrUpdate(id, false);
      }
      const base_row = this.sectionLines[index];
      if (
        base_row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
        base_row.TreeTypeProp?.ValueAsObject === 'I'
      ) {
        return;
      }

      for (let i = index + 1; i < this.sectionLines.length; i++) {
        const row = this.sectionLines[i];

        if (
          row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
          row.TreeTypeProp?.ValueAsObject === 'I'
        ) {
          this.setOfCheckedId.add(row.Id);
          //this.setOfCheckedIdFromParent.add({ row.Id, fromParent: true });
          this.addOrUpdate(row.Id, true);
          const innerIndex =
            i -
            (this.enablePaginationInLineSection
              ? (this.currentPage - 1) * this.pageSizeInLineSection
              : 0);
          this.updateCheckedSet(row.Id, innerIndex, checked, true);
        }
        if (
          !(
            row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
            row.TreeTypeProp?.ValueAsObject === 'I'
          )
        ) {
          break;
        }
      }
    } else {
      this.setOfCheckedId.delete(id);
      const itemToDelete = [...this.setOfCheckedIdFromParent].find(
        (x) => x.id === id,
      );
      if (itemToDelete) {
        this.setOfCheckedIdFromParent.delete(itemToDelete);
      }

      const base_row = this.sectionLines[index];
      if (
        base_row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
        base_row.TreeTypeProp?.ValueAsObject === 'I'
      ) {
        return;
      }

      for (let i = index + 1; i < this.sectionLines.length; i++) {
        const row = this.sectionLines[i];

        if (
          row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
          row.TreeTypeProp?.ValueAsObject === 'I'
        ) {
          this.setOfCheckedId.delete(row.Id);

          const itemToDelete = [...this.setOfCheckedIdFromParent].find(
            (x) => x.id === row.Id,
          );
          if (itemToDelete) {
            this.setOfCheckedIdFromParent.delete(itemToDelete);
          }

          const innerIndex =
            i -
            (this.enablePaginationInLineSection
              ? (this.currentPage - 1) * this.pageSizeInLineSection
              : 0);
          this.updateCheckedSet(row.Id, innerIndex, checked);
        }
        if (
          !(
            row.TreeTypeProp?.ValueAsObject === 'iIngredient' ||
            row.TreeTypeProp?.ValueAsObject === 'I'
          )
        ) {
          break;
        }
      }
    }
  }

  rowPlus(row: RecordLine) {
    row.Id++;
    row.Properties.find((x) => x.Name === 'LineNum').ValueAsObject++;
    row.Properties.find((x) => x.Name === 'U_ITM_LINENUM').ValueAsObject++;
  }

  rowMinus(row: RecordLine) {
    row.Id--;
    row.Properties.find((x) => x.Name === 'LineNum').ValueAsObject--;
    row.Properties.find((x) => x.Name === 'U_ITM_LINENUM').ValueAsObject--;
  }

  sLinePlus(row: SpecialLines) {
    const indexOfRow = this.sectionLines.indexOf(row);
    const nextLine = this.sectionLines[indexOfRow + 1];
    if (nextLine !== undefined && nextLine.LineSeq !== undefined) {
      nextLine.LineSeq--;
      row.LineSeq++;
    } else if (nextLine.Id !== undefined) {
      row.AftLineNum++;
    }
  }

  sLineMinus(row: SpecialLines) {
    const indexOfRow = this.sectionLines.indexOf(row);
    const lastLine = this.sectionLines[indexOfRow - 1];
    if (lastLine !== undefined && lastLine.LineSeq !== undefined) {
      lastLine.LineSeq++;
      row.LineSeq--;
    } else if (lastLine.Id !== undefined) {
      row.AftLineNum--;
    }
  }

  addSelectedRows() {
    const Lines = [];
    let productionOrderReferenced: boolean;
    this.documentSources.forEach((source) => {
      this.openDocumentRows[source.Id].forEach((row) => {
        if (row.Selected === true) {
          if (source.Id === '202') {
            productionOrderReferenced = true;
          }
          console.log('Row to be copied', row);
          this.addLineToTable_more(row, source.Id);
          let IsExist = false;
          Lines.forEach((line) => {
            if (line.DocEntry === row.DocEntry && line.ObjType === source.Id) {
              IsExist = true;
              return;
            }
          });
          if (IsExist === false) {
            Lines.push({
              DocEntry: row.DocEntry,
              ObjType: source.Id,
            });
          }
        }
      });
    });

    this.showCopyFromDrawer = false;
  }

  addLineToTable_more(data: any, objectId: string) {
    if (data.Rate == 0 || data.Rate == '0') {
      data.Rate = 1;
    }
    console.log('addLineToTable', data);

    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      let recordCategory: RecordCategory = null;
      const DocCurr = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'BPCurrency')?.ValueAsObject;

      const DescriptionProp = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'Description');

      if (
        DescriptionProp != null &&
        (DescriptionProp.ValueAsObject == null ||
          DescriptionProp.ValueAsObject === undefined ||
          DescriptionProp.ValueAsObject === '')
      ) {
        //DescriptionProp.ValueAsObject = data.QuotName;
        //DescriptionProp.Value = data.QuotName;
        DescriptionProp.ValueAsObject = data.OpprName;
        DescriptionProp.Value = data.OpprName;
      }

      const NumAtCardProp = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'NumAtCard');

      if (
        g.copyNumAtCardWhenCopyFrom &&
        NumAtCardProp != null &&
        data.NumAtCard != null &&
        data.NumAtCard != undefined
      ) {
        NumAtCardProp.ValueAsObject = data.NumAtCard;
        NumAtCardProp.Value = data.NumAtCard;
      }

      const section = this.moduleStructure.module.Sections.find(
        (sec) =>
          sec.XmlTagName ===
          'BlanketAgreements_ItemsLines|BlanketAgreements_ItemsLine',
      );
      this.recordModel.Categories.forEach((category) => {
        if (category.Id === section.XmlTagName) {
          recordCategory = category;
          return;
        }
      });

      if (recordCategory == null) {
        recordCategory = {
          Id: section.XmlTagName,
          Lines: [],
          DeletedLines: [],
        };
        this.recordModel.Categories.push(recordCategory);
      }

      let recordLine: RecordLine = null;

      for (let i = 0; i < recordCategory.Lines.length; i++) {
        const properties = recordCategory.Lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemNo');
        if (
          itemProp != null &&
          itemProp !== undefined &&
          data['ItemCode'] === itemProp.ValueAsObject
        ) {
          recordLine = recordCategory.Lines[i];
          break;
        }
      }

      if (recordLine === null) {
        this.addLineToTable();
      }

      if (recordLine === null) {
        recordLine =
          this.recordCategory.Lines[this.recordCategory.Lines.length - 1];
        recordLine.IsNew = true;
      } else {
        recordLine.IsNew = false;
      }

      console.log(recordLine);

      if (recordLine.IsNew) {
        for (const property of recordLine.Properties) {
          if (g.userIdentity.Area == 3) {
            // property.Disabled = true;
            property.ReadOnly = true;
          }

          let valueProperty = !data.hasOwnProperty(property.Name)
            ? !data.hasOwnProperty(property.FieldName)
              ? null
              : data[property.FieldName]
            : data[property.Name];

          if (
            valueProperty === null &&
            property.Name !== 'AgreementRowNumber' &&
            property.Name !== 'ItemDescription' &&
            property.Name !== 'TaxValue' &&
            property.Name !== 'UnitPrice' &&
            property.Name !== 'BASE_LineTotal'
          ) {
            property.Value = '';
            property.ValueAsObject = '';
          } else if (
            [
              'LineNum',
              'BaseEntry',
              'BaseLine',
              'BaseType',
              'AgreementRowNumber',
            ].indexOf(property.Name) === -1
          ) {
            if (property.Name === 'PriceCurrency') {
              const documentSection = this.recordModel.Categories.find(
                (x) => x.Id === 'BlanketAgreement',
              );
              const currency = documentSection.Lines[0].Properties.find(
                (x) => x.Name === 'BPCurrency',
              );
              if (
                valueProperty.toString() != null &&
                valueProperty.toString() !== undefined &&
                valueProperty.toString() !== ''
              ) {
                currency.Value = valueProperty.toString();
                currency.ValueAsObject = valueProperty;
              }
            }

            if (property.DataType === FieldDataType.Select) {
              const field = section.Fields.find(
                (p) =>
                  p.PropertyName === property.Name && p.Id === property.FieldId,
              );

              RecordModel.getOptions(
                field,
                this.recordModel,
                property,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
              property.Value = valueProperty.toString();
              property.ValueAsObject = valueProperty.toString();
            } else {
              if (property.Name == 'TaxValue') {
                console.log('Tax Value');
                if (Number(data.VatAppld) === 0) {
                  property.ValueAsObject = Number(data.VatSum);
                } else {
                  property.ValueAsObject =
                    Number(data.VatSum) - Number(data.VatAppld);
                }

                property.Value = property.ValueAsObject.toString();
              } else if (property.Name == 'TaxCode') {
                console.log('Tax Code');
                property.ValueAsObject = data.TaxCode;
                property.Value = property.ValueAsObject.toString();
              } else if (property.Name == 'UnitPrice') {
                property.ValueAsObject = data.PriceBefDi;
                property.Value = property.ValueAsObject.toString();
              } else {
                property.Value = valueProperty?.toString();
                property.ValueAsObject = valueProperty;
              }
            }
          }
        }

        for (const property1 of recordLine.Properties) {
          const field = section.Fields.find(
            (p) => p.PropertyName === property1.Name,
          );

          if (field.AdditionalInformationParsed.EditableInList) {
            this.layoutService.getFieldValueOnParentChange(
              this.recordModel,
              recordCategory,
              recordLine,
              property1,
              field.SQLStatementParentChanged,
              field,
              this.moduleStructure,
              true,
            );
          }
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'PlannedQuantity') !=
          null
        ) {
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).Value = data.OpenQty;
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).ValueAsObject = data.OpenQty;
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_IDS') != null
        ) {
          const baseIds = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_IDS',
          ).Value;
          if (baseIds != null && baseIds !== undefined && baseIds !== '') {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = baseIds + ';' + data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = baseIds + ';' + data.DocEntry;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = data.DocEntry;
          }
        }

        if (
          this.recordModel.copiedQuotEntries.findIndex(
            (DocEntry) => DocEntry === data.DocEntry.toString(),
          ) === -1
        ) {
          this.recordModel.copiedQuotEntries.push(data.DocEntry.toString());
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_LINES') !=
          null
        ) {
          const baselines = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_LINES',
          ).Value;
          if (
            baselines != null &&
            baselines !== undefined &&
            baselines !== ''
          ) {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = baselines + ';' + data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = baselines + ';' + data.LineNum;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = data.LineNum;
          }
        }
        // UDFs
      } else {
        if (
          recordLine.Properties.find((x) => x.Name === 'PlannedQuantity') !=
          null
        ) {
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).Value += data.OpenQty;
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).ValueAsObject += data.OpenQty;
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_IDS') != null
        ) {
          const baseIds = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_IDS',
          ).Value;
          if (baseIds != null && baseIds !== undefined && baseIds !== '') {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = baseIds + ';' + data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = baseIds + ';' + data.DocEntry;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = data.DocEntry;
          }
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_LINES') !=
          null
        ) {
          const baselines = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_LINES',
          ).Value;
          if (
            baselines != null &&
            baselines !== undefined &&
            baselines !== ''
          ) {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = baselines + ';' + data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = baselines + ';' + data.LineNum;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = data.LineNum;
          }
        }
        //UDFs
      }

      this.layoutService.linesChanged.emit(recordCategory);
    }
  }

  setChildChecked(dataSourceId, docRow) {
    console.log('setChildChecked');

    let index = 0;
    let checked = docRow.Selected;
    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
        const row = this.openDocumentRows[dataSourceId][i];
        if (row.DocEntry === docRow.DocEntry) {
          row.Selected = checked;
        }
      }
    } else {
      for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
        const row = this.openDocumentRows[dataSourceId][i];
        if (
          row.DocEntry === docRow.DocEntry &&
          row.LineNum === docRow.LineNum
        ) {
          index = i;
          break;
        }
      }

      for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
        const row = this.openDocumentRows[dataSourceId][i];
        if (i > index && row.TreeType === 'I') {
          row.Selected = checked;
        }
        if (i > index && row.TreeType !== 'I') {
          break;
        }
      }
    }
  }

  applyFilters(id) {
    console.log(this.filters);
    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      this.filteredData = this.minimizedOpenDocumentRowsForBA[id].filter(
        (row) =>
          (!this.filters.docNum ||
            row.DocNum.toString()
              .toLowerCase()
              .includes(this.filters.docNum.toString().toLowerCase())) &&
          (!this.filters.quotName ||
            (row.QuotName != null &&
              row.QuotName.toString()
                .toLowerCase()
                .includes(this.filters.quotName.toString().toLowerCase()))) &&
          (!this.filters.numAtCard ||
            (row.NumAtCard != null &&
              row.NumAtCard.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase()))),
      );
    } else {
      this.filteredData = this.openDocumentRows[id].filter(
        (row) =>
          (!this.filters.docNum ||
            row.DocNum.toString()
              .toLowerCase()
              .includes(this.filters.docNum.toString().toLowerCase())) &&
          (!this.filters.itemCode ||
            row.ItemCode.toString()
              .toLowerCase()
              .includes(this.filters.itemCode.toString().toLowerCase())) &&
          (!this.filters.description ||
            row.Dscription.toString()
              .toLowerCase()
              .includes(this.filters.description.toString().toLowerCase())) &&
          (!this.filters.numAtCard ||
            (row.NumAtCard != null &&
              row.NumAtCard.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase()))),
      );
    }
  }

  openCopyFromDrawer() {
    const headerCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'BlanketAgreement',
    );

    if (
      headerCat != null &&
      headerCat !== undefined &&
      headerCat.Lines != null &&
      headerCat.Lines !== undefined &&
      headerCat.Lines.length !== 0
    ) {
      const cardCodeProp = headerCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'BPCode',
      );
      let cardCode = '';
      if (cardCodeProp != null && cardCodeProp !== undefined) {
        cardCode = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'BPCode',
        ).ValueAsObject;
      }

      if (cardCode == null || cardCode === undefined || cardCode === '') {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          this.layoutService.translate(
            'Please select a business partner before.',
          ),
        );
        return;
      }

      if (
        this.blanketAgreementStatus === 'A' ||
        this.blanketAgreementStatus === 'asApproved'
      ) {
        this.notificationService.error(
          this.layoutService.translate('Error'),
          '<b>You cannot add items to "Approved" BlanketAgreement</b>',
        );
        return;
      }

      const openSourceDoc$ = this.layoutService
        .getSourceDocument(this.moduleStructure.module.Id)
        .subscribe((d: any) => {
          this.showCopyFromDrawer = true;
          this.documentSources = d.SourceDocuments;
          if (this.documentSources.length === 0) {
            this.notificationService.error(
              this.layoutService.translate('No Source Documents'),
              this.layoutService.translate(
                'Please be sure that you have at least one source document.',
              ),
            );
            return;
          }
          console.log(this.documentSources);
          this.documentSources.forEach((source) => {
            this.openDocumentRows[source.Id] = [];
            this.minimizedOpenDocumentRowsForBA[source.Id] = [];
            const openDocumentRows$ = this.layoutService
              .getOpenDocumentRows(
                this.moduleStructure.module.Id.toString(),
                source.TableName + (source.IsReserved ? '_R' : ''),
                cardCode,
                'BI',
              )
              .subscribe((result: any) => {
                this.openDocumentRows[source.Id] = result.Rows;

                if (source.Id === '23') {
                  this.openDocumentRows[source.Id] = this.openDocumentRows[
                    source.Id
                  ].filter(
                    (element) =>
                      this.recordModel.copiedQuotEntries.findIndex(
                        (DocEntry) => DocEntry === element.DocEntry.toString(),
                      ) === -1,
                  );
                }

                this.minimizedOpenDocumentRowsForBA[source.Id] = Array.from(
                  new Map(
                    this.openDocumentRows[source.Id].map((item) => [
                      item.DocEntry, // Use DocEntry as a unique key for grouping
                      {
                        NumAtCard: item.NumAtCard,
                        DocEntry: item.DocEntry,
                        DocNum: item.DocNum,
                        DocDate: item.DocDate,
                        DocDueDate: item.DocDueDate,
                        DocEntry1: item.DocEntry1,
                        QuotName: item.QuotName,
                      },
                    ]),
                  ).values(),
                );

                this.minimizedOpenDocumentRowsForBA[source.Id].forEach(
                  (element) => {
                    element.Selected = false;
                  },
                );

                this.openDocumentRows[source.Id].forEach((element) => {
                  element.Selected = false;
                });
                console.log(this.openDocumentRows);

                this.filteredData =
                  this.minimizedOpenDocumentRowsForBA[
                    this.documentSources[0].Id
                  ];
              });
            this.subscribers.push(openDocumentRows$);
          });
        });
      this.subscribers.push(openSourceDoc$);
    }
  }

  /*processDeliverSchedule(lineId) {
    let recordLine = this.recordModel.Categories.find(
      (c) => c.Id === 'Document_Lines'
    ).Lines.find((l) => l.Id === lineId);

    let itemCode = recordLine.Properties.find(
      (p) => p.Name === 'ItemCode'
    ).ValueAsObject;

    let scheduleSuggestionsStr = recordLine.Properties.find(
      (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
    ).ValueAsObject;

    let scheduleSuggestions = JSON.parse(scheduleSuggestionsStr);

    const groupedData = this.groupAndSumByUserDeliveryDate(scheduleSuggestions);
    console.log(groupedData);

    for (const date in groupedData) {
      if (groupedData.hasOwnProperty(date)) {
        const { UserDeliveryDate, TotalQuantity } = groupedData[date];
        //console.log(`Date: ${UserDeliveryDate}, Total Quantity: ${TotalQuantity}`);
        this.addLineToTable();

        LayoutService.setValue(
          this.recordCategory.Lines[
            this.recordCategory.Lines.length - 1
          ].Properties.find((p) => p.Name === 'ItemCode'),
          itemCode,
          this.layoutService,
          this.recordModel,
          this.recordCategory.Lines[this.recordCategory.Lines.length - 1].Id,
          this.section.XmlTagName,
          this.moduleStructure
        );
      }
    }
  }

  groupAndSumByUserDeliveryDate(data) {
    return data.reduce((acc, item) => {
      const formattedDate = this.formatDateWithoutTime(item.UserDeliveryDate);
      if (!acc[formattedDate]) {
        acc[formattedDate] = {
          UserDeliveryDate: formattedDate,
          TotalQuantity: 0,
        };
      }
      acc[formattedDate].TotalQuantity += item.Quantity;
      return acc;
    }, {});
  }

  formatDateWithoutTime(dateString: string): string {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Extract the YYYY-MM-DD portion
  }*/
}
